<template>
    <div class="setarea">
        <div class="setarea-a">
            <el-row :gutter="12">
                <el-col class="mudiaCol">
                    <el-card shadow="hover" style="height:220px;margin-bottom:5px;">
                        <el-row>
                            <el-col :span="18" style="height:40px;line-height:40px;font-size:18px;color:#000;"><span><img
                                        :src="bg_Icon.quyu_icon" alt=""
                                        style="vertical-align:middle"></span><span>安全区域设置</span> </el-col>
                            <el-col :span="6"
                                style="height:40px;line-height:40px;font-size:18px;color:#000"><span><el-button
                                        style="float:rigfht;" type="success"
                                        @click="setSafe">立即设置</el-button></span></el-col>
                        </el-row>
                        <el-row v-if="SafeDetailList.length > 0"
                            style="height:140px;display: -webkit-flex;display:flex;flex-direction:row;justify-content:center;align-items:center;">
                            <el-button type="primary" @click="safeSetDetail">安全区域设置详情</el-button>
                        </el-row>
                        <el-row v-else
                            style="height:140px;display: -webkit-flex;display:flex;flex-direction:row;justify-content:center;align-items:center;">
                            <span style="font-size:30px;color:red;">暂无数据</span>
                        </el-row>
                    </el-card>
                </el-col>
                <el-col class="mudiaCol">
                    <el-card shadow="hover" style="height:220px;margin-bottom:5px;">
                        <el-row>
                            <el-col :span="18" style="height:40px;line-height:40px;font-size:18px;color:#000"><span><img
                                        :src="bg_Icon.number_icon" alt=""
                                        style="vertical-align:middle"></span><span>亲情号码设置</span> </el-col>
                            <el-col :span="6"
                                style="height:40px;line-height:40px;font-size:18px;color:#000"><span><el-button
                                        style="float:rigfht;" type="success"
                                        @click="setEditPhone">设置修改</el-button></span></el-col>
                        </el-row>
                        <div style="margin:20px;">
                            <el-row style="margin-top:10px;">
                                <el-col :span="10">
                                    <div class="grid-content bg-purple">按键</div>
                                </el-col>
                                <el-col :span="10">
                                    <div class="grid-content bg-purple-light">亲情号码</div>
                                </el-col>
                            </el-row>
                            <el-row style="margin-top:10px;">
                                <el-col :span="10">
                                    <div class="grid-content bg-purple">红键</div>
                                </el-col>
                                <el-col :span="10">
                                    <div class="grid-content bg-purple-light" v-if="setMessage.redKeyNumber">
                                        {{ setMessage.redKeyNumber }}</div>
                                    <div class="grid-content bg-purple-light" v-else>暂无数据</div>
                                </el-col>
                            </el-row>
                            <el-row style="margin-top:10px;">
                                <el-col :span="10">
                                    <div class="grid-content bg-purple">黄键</div>
                                </el-col>
                                <el-col :span="10">
                                    <div class="grid-content bg-purple-light" v-if="setMessage.yellowKeyNumber">
                                        {{ setMessage.yellowKeyNumber }}</div>
                                    <div class="grid-content bg-purple-light" v-else>暂无数据</div>
                                </el-col>
                            </el-row>
                            <el-row style="margin-top:10px;">
                                <el-col :span="10">
                                    <div class="grid-content bg-purple">绿键</div>
                                </el-col>
                                <el-col :span="10">
                                    <div class="grid-content bg-purple-light" v-if="setMessage.greenKeyNumber">
                                        {{ setMessage.greenKeyNumber }}</div>
                                    <div class="grid-content bg-purple-light" v-else>暂无数据</div>
                                </el-col>
                            </el-row>
                        </div>
                    </el-card>
                </el-col>
                <el-col class="mudiaCol">
                    <el-card shadow="hover" style="height:220px;margin-bottom:5px;">
                        <el-row>
                            <el-col :span="18" style="height:40px;line-height:40px;font-size:18px;color:#000"><span><img
                                        :src="bg_Icon.remind_icon" alt=""
                                        style="vertical-align:middle"></span><span>智能提醒设置</span> </el-col>
                            <el-col :span="6"
                                style="height:40px;line-height:40px;font-size:18px;color:#000"><span><el-button
                                        style="float:rigfht;" type="success"
                                        @click="quickSetRemind">立即设置</el-button></span></el-col>
                        </el-row>
                        <el-row v-if="getRemindList.length > 0"
                            style="height:140px;display: -webkit-flex;display:flex;flex-direction:row;justify-content:center;align-items:center;">
                            <el-button type="primary" @click="dialogFormVisibleRemindDetail = true">智能提醒设置详情</el-button>
                        </el-row>
                        <el-row v-else
                            style="height:140px;display: -webkit-flex;display:flex;flex-direction:row;justify-content:center;align-items:center;">
                            <span style="font-size:30px;color:red;">暂无数据</span>
                        </el-row>
                    </el-card>
                </el-col>
                <el-col class="mudiaCol">
                    <el-card shadow="hover" style="height:220px;margin-bottom:5px;">
                        <el-row>
                            <el-col :span="18" style="height:40px;line-height:40px;font-size:18px;color:#000"><span><img
                                        :src="bg_Icon.frequency_icon" alt=""
                                        style="vertical-align:middle"></span><span>设置时区</span> </el-col>
                        </el-row>
                        <el-row :gutter="20" style="margin-top:20px;">
                            <el-col :span="6">
                                <div class="grid-content bg-purple" align="center">名称</div>
                            </el-col>
                            <el-col :span="14">
                                <div class="grid-content bg-purple" align="center">时区</div>
                            </el-col>
                            <el-col :span="4">
                                <div class="grid-content bg-purple" align="center">操作</div>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20" style="margin-top:5px;line-height:40px;">
                            <el-col :span="6">
                                <div class="grid-content bg-purple" align="center">当前时区</div>
                            </el-col>
                            <el-col :span="14">
                                <div class="grid-content bg-purple" align="center">
                                    <div v-if="!editingtimeZone">
                                        <el-select v-model="timeZone" placeholder="请选择" style="width:150px;">
                                            <el-option v-for="item in timeZoneList" :key="item.value" :label="item.value"
                                                :value="item.key">
                                            </el-option>
                                        </el-select>
                                    </div>
                                    <div v-else>
                                        <span v-if="setMessage.timeZone == -12">西12区</span>
                                        <span v-if="setMessage.timeZone == -11">西11区</span>
                                        <span v-if="setMessage.timeZone == -10">西10区</span>
                                        <span v-if="setMessage.timeZone == -9">西9区</span>
                                        <span v-if="setMessage.timeZone == -8">西8区</span>
                                        <span v-if="setMessage.timeZone == -7">西7区</span>
                                        <span v-if="setMessage.timeZone == -6">西6区</span>
                                        <span v-if="setMessage.timeZone == -5">西5区</span>
                                        <span v-if="setMessage.timeZone == -4.5">西4半区</span>
                                        <span v-if="setMessage.timeZone == -4">西4区</span>
                                        <span v-if="setMessage.timeZone == -3.5">西3半区</span>
                                        <span v-if="setMessage.timeZone == -3">西3区</span>
                                        <span v-if="setMessage.timeZone == -2">西2半区</span>
                                        <span v-if="setMessage.timeZone == -1">西1区</span>
                                        <span v-if="setMessage.timeZone == 0">0时区</span>
                                        <span v-if="setMessage.timeZone == 1">东1区</span>
                                        <span v-if="setMessage.timeZone == 2">东2区</span>
                                        <span v-if="setMessage.timeZone == 3">东3区</span>
                                        <span v-if="setMessage.timeZone == 3.5">东3半区</span>
                                        <span v-if="setMessage.timeZone == 4">东4区</span>
                                        <span v-if="setMessage.timeZone == 4.5">东4半区</span>
                                        <span v-if="setMessage.timeZone == 5">东5区</span>
                                        <span v-if="setMessage.timeZone == 5.5">东5半区</span>
                                        <span v-if="setMessage.timeZone == 5.75">加德满都</span>
                                        <span v-if="setMessage.timeZone == 6">东6区</span>
                                        <span v-if="setMessage.timeZone == 7">东7区</span>
                                        <span v-if="setMessage.timeZone == 8">东8区</span>
                                        <span v-if="setMessage.timeZone == 9">东9区</span>
                                        <span v-if="setMessage.timeZone == 10">东10区</span>
                                        <span v-if="setMessage.timeZone == 11">东11区</span>
                                        <span v-if="setMessage.timeZone == 12">东12区</span>
                                        <span v-if="setMessage.timeZone == 13">东13区</span>
                                        <span v-if="setMessage.timeZone == null">暂无数据</span>
                                    </div>
                                </div>
                            </el-col>
                            <el-col :span="4">
                                <div class="grid-content bg-purple" align="center">
                                    <el-button size="mini" type="warning" v-if="editingtimeZone"
                                        @click="handleEdittimeZone('gpsRate')">修改</el-button>
                                    <el-button size="mini" type="success" v-if="!editingtimeZone"
                                        @click="handleSavetimeZone('gpsRate')">保存</el-button>
                                </div>
                            </el-col>
                        </el-row>
                    </el-card>
                </el-col>
                <el-col class="mudiaCol">
                    <el-card shadow="hover" style="height:220px;margin-bottom:5px;">
                        <el-row>
                            <el-col :span="18" style="height:40px;line-height:40px;font-size:18px;color:#000"><span><img
                                        :src="bg_Icon.volume_icon" alt=""
                                        style="vertical-align:middle"></span><span>设置音量</span> </el-col>
                        </el-row>
                        <div class="block">
                            <div class="block-a" style="text-align:center;color:blue;font-size:18px;font-weight:500;">
                                音量大小{{ volume }}
                            </div>
                            <div class="block-b" style="overflow:hidden;">
                                <span class="demonstration" style="text-align:center;float:left;color:green">1</span>
                                <span class="demonstration" style="text-align:center;float:right;color:red;">7</span>
                            </div>
                            <el-slider v-model="volume" :step="1" :min="1" :max="7" show-stops @change="changeVolumn">
                            </el-slider>
                        </div>
                    </el-card>
                </el-col>
                <el-col class="mudiaCol">
                    <el-card shadow="hover" style="height:220px;margin-bottom:5px;">
                        <el-row>
                            <el-col :span="18" style="height:40px;line-height:40px;font-size:18px;color:#000"><span><img
                                        :src="bg_Icon.Timeslot_icon" alt=""
                                        style="vertical-align:middle"></span><span>设置上传间隔</span> </el-col>
                        </el-row>
                        <el-row :gutter="20" style="margin-bottom:5px;">
                            <el-col :span="4">
                                <div class="grid-content bg-purple" align="center">名称</div>
                            </el-col>
                            <el-col :span="16">
                                <div class="grid-content bg-purple" align="center">间隔时间</div>
                            </el-col>
                            <el-col :span="4">
                                <div class="grid-content bg-purple" align="center">操作</div>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20" style="margin-bottom:5px;line-height:40px;">
                            <el-col :span="4">
                                <div class="grid-content bg-purple" align="center">GPS</div>
                            </el-col>
                            <el-col :span="16">
                                <div class="grid-content bg-purple" align="center">
                                    <div v-if="!editingGpsRate">
                                        <el-select v-model="gpsRate" placeholder="请选择" style="width:150px;">
                                            <el-option v-for="item in Optionitem" :key="item.value" :label="item"
                                                :value="item">
                                            </el-option>
                                        </el-select>
                                    </div>
                                    <!-- <div v-if="!editingGpsRate">
                                        <input class="browsers" list="browsers"  v-model="gpsRate">
                                        <datalist id="browsers"  size="10">
                                            <option  v-for="(o,index) in Optionitem" :value="o" :key="index"/>
                                        </datalist>
                                         
                                    </div> -->

                                    <div v-else><span v-if="setMessage.gpsRate">{{ setMessage.gpsRate }}</span><span
                                            v-else>暂无数据</span></div>
                                </div>
                            </el-col>
                            <el-col :span="4">
                                <div class="grid-content bg-purple" align="center">
                                    <el-button size="mini" type="warning" v-if="editingGpsRate"
                                        @click="handleEditGps('gpsRate')">修改</el-button>
                                    <el-button size="mini" type="success" v-if="!editingGpsRate"
                                        @click="handleSaveGps('gpsRate')">保存</el-button>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20" style="margin-bottom:5px;line-height:40px;">
                            <el-col :span="4">
                                <div class="grid-content bg-purple" align="center">心率</div>
                            </el-col>
                            <el-col :span="16">
                                <div class="grid-content bg-purple" align="center">
                                    <div v-if="!editingHeartRate">
                                        <el-select v-model="heartRate" placeholder="请选择" style="width:150px;">
                                            <el-option v-for="item in Optionitem" :key="item.value" :label="item"
                                                :value="item">
                                            </el-option>
                                        </el-select>
                                    </div>
                                    <div v-else><span v-if="setMessage.heartRate">{{ setMessage.heartRate }}</span><span
                                            v-else>暂无数据</span></div>
                                </div>
                            </el-col>
                            <el-col :span="4">
                                <div class="grid-content bg-purple" align="center">
                                    <el-button size="mini" type="warning" v-if="editingHeartRate"
                                        @click="handleEditheart('heartRate')">修改</el-button>
                                    <el-button size="mini" type="success" v-if="!editingHeartRate"
                                        @click="handleSaveheart('heartRate')">保存</el-button>
                                </div>
                            </el-col>
                        </el-row>
                    </el-card>
                </el-col>
                <el-col class="mudiaCol">
                    <el-card shadow="hover" style="height:220px;margin-bottom:5px;">
                        <el-row>
                            <el-col :span="18" style="height:40px;line-height:40px;font-size:18px;color:#000"><span><img
                                        :src="bg_Icon.time_icon" alt=""
                                        style="vertical-align:middle"></span><span>时间段设置</span> </el-col>
                        </el-row>
                        <el-row :gutter="20" style="margin-bottom:5px;">
                            <el-col :span="6">
                                <div class="grid-content bg-purple" align="center">名称</div>
                            </el-col>
                            <el-col :span="14">
                                <div class="grid-content bg-purple" align="center">间隔时间</div>
                            </el-col>
                            <el-col :span="4">
                                <div class="grid-content bg-purple" align="center">操作</div>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20" style="margin-bottom:5px;line-height:40px;">
                            <el-col :span="6">
                                <div class="grid-content bg-purple" align="center">GPS静默</div>
                            </el-col>
                            <el-col :span="14">
                                <div class="grid-content bg-purple" align="center">
                                    <el-time-picker v-model="GpsPeriodStart" placeholder="开始" format="HH:mm"
                                        value-format="HH:mm" style="width:100px;" v-if="!editingGpsPeriod">
                                    </el-time-picker>
                                    <el-time-picker v-model="GpsPeriodEnd" placeholder="结束" format="HH:mm"
                                        value-format="HH:mm" style="width:100px;" clear-icon="el-icon-circle-close"
                                        v-if="!editingGpsPeriod">
                                    </el-time-picker>
                                    <div v-else><span v-if="gpsperiodjg">{{ gpsperiodjg }}</span><span v-else>暂无数据</span>
                                    </div>
                                </div>
                            </el-col>
                            <el-col :span="4">
                                <div class="grid-content bg-purple" align="center">
                                    <el-button size="mini" type="warning" v-if="editingGpsPeriod"
                                        @click="handleEditGpsPeriod('gpsRate')">修改</el-button>
                                    <el-button size="mini" type="success" v-if="!editingGpsPeriod"
                                        @click="handleSaveGpsPeriod('gpsRate')">保存</el-button>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20" style="margin-bottom:5px;line-height:40px;">
                            <el-col :span="6">
                                <div class="grid-content bg-purple" align="center">低电量提醒</div>
                            </el-col>
                            <el-col :span="14">
                                <div class="grid-content bg-purple" align="center">
                                    <el-time-picker v-model="PowerPeriodStart" placeholder="开始" format="HH:mm"
                                        value-format="HH:mm" style="width:100px;" v-if="!editingPowerPeriod">
                                    </el-time-picker>
                                    <el-time-picker v-model="PowerPeriodEnd" placeholder="结束" format="HH:mm"
                                        value-format="HH:mm" style="width:100px;" v-if="!editingPowerPeriod">
                                    </el-time-picker>
                                    <div v-else><span v-if="powerperiodjg">{{ powerperiodjg }}</span><span v-else>暂无数据</span>
                                    </div>
                                </div>
                            </el-col>
                            <el-col :span="4">
                                <div class="grid-content bg-purple" align="center">
                                    <el-button size="mini" type="warning" v-if="editingPowerPeriod"
                                        @click="handleEditPowerPeriod('heartRate')">修改</el-button>
                                    <el-button size="mini" type="success" v-if="!editingPowerPeriod"
                                        @click="handleSavePowerPeriod('heartRate')">保存</el-button>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20" style="margin-bottom:5px;line-height:40px;">
                            <el-col :span="6">
                                <div class="grid-content bg-purple" align="center">余额不足</div>
                            </el-col>
                            <el-col :span="14">
                                <div class="grid-content bg-purple" align="center">
                                    <el-time-picker v-model="balancePeriodStart" placeholder="开始" format="HH:mm"
                                        value-format="HH:mm" style="width:100px;" v-if="!editingbalancePeriod">
                                    </el-time-picker>
                                    <el-time-picker v-model="balancePeriodEnd" placeholder="结束" format="HH:mm"
                                        value-format="HH:mm" style="width:100px;" v-if="!editingbalancePeriod">
                                    </el-time-picker>
                                    <div v-else><span v-if="balanceperiodjg">{{ balanceperiodjg }}</span><span
                                            v-else>暂无数据</span></div>
                                </div>
                            </el-col>
                            <el-col :span="4">
                                <div class="grid-content bg-purple" align="center">
                                    <el-button size="mini" type="warning" v-if="editingbalancePeriod"
                                        @click="handleEditbalancePeriod('heartRate')">修改</el-button>
                                    <el-button size="mini" type="success" v-if="!editingbalancePeriod"
                                        @click="handleSavebalancePeriod('heartRate')">保存</el-button>
                                </div>
                            </el-col>
                        </el-row>
                    </el-card>
                </el-col>
                <el-col class="mudiaCol">
                    <el-card shadow="hover" style="height:220px;margin-bottom:5px;">
                        <el-row>
                            <el-col :span="18" style="height:40px;line-height:40px;font-size:18px;color:#000"><span><img
                                        :src="bg_Icon.switch_icon" alt=""
                                        style="vertical-align:middle"></span><span>开关设置</span> </el-col>
                            <div style="margin:20px;">
                                <el-row style="margin-top:15px;">
                                    <el-col :span="12">
                                        <div class="grid-content bg-purple" align="center">开关名称</div>
                                    </el-col>
                                    <el-col :span="12">
                                        <div class="grid-content bg-purple-light" align="center">设置</div>
                                    </el-col>
                                </el-row>
                                <el-row style="margin-top:10px;">
                                    <el-col :span="12">
                                        <div class="grid-content bg-purple" align="center">GPS开关</div>
                                    </el-col>
                                    <el-col :span="12">
                                        <div class="grid-content bg-purple-light" align="center">
                                            <el-switch v-model="switchGps" active-text="开" inactive-text="关"
                                                active-color="#13ce66" @change="changeswitchGps">
                                            </el-switch>
                                        </div>
                                    </el-col>

                                </el-row>
                                <el-row style="margin-top:10px;">
                                    <el-col :span="12">
                                        <div class="grid-content bg-purple" align="center">白名单开关</div>
                                    </el-col>
                                    <el-col :span="12">
                                        <div class="grid-content bg-purple-light" align="center">
                                            <el-switch v-model="switchWhite" active-text="开" inactive-text="关"
                                                active-color="#13ce66" @change="changeswitchWhite">
                                            </el-switch>
                                        </div>
                                    </el-col>
                                </el-row>
                                <el-row style="margin-top:10px;">
                                    <el-col :span="12">
                                        <div class="grid-content bg-purple" align="center">黄键短信开关</div>
                                    </el-col>
                                    <el-col :span="12">
                                        <div class="grid-content bg-purple-light" align="center">
                                            <el-switch v-model="switchYellowKeySms" active-text="开" inactive-text="关"
                                                active-color="#13ce66" @change="changeswitchYellowKeySms">
                                            </el-switch>
                                        </div>
                                    </el-col>
                                </el-row>
                                <el-row style="margin-top:10px;">
                                    <el-col :span="12">
                                        <div class="grid-content bg-purple" align="center">红键短信开关</div>
                                    </el-col>
                                    <el-col :span="12">
                                        <div class="grid-content bg-purple-light" align="center">
                                            <el-switch v-model="switchRedKeySms" active-text="开" inactive-text="关"
                                                active-color="#13ce66" @change="changeswitchRedKeySms">
                                            </el-switch>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                        </el-row>
                    </el-card>
                </el-col>
                <el-col class="mudiaCol">
                    <el-card shadow="hover" style="height:220px;margin-bottom:5px;">
                        <el-row>
                            <el-col :span="18" style="height:40px;line-height:40px;font-size:18px;color:#000"><span><img
                                        :src="bg_Icon.Whitelist_icon" alt=""
                                        style="vertical-align:middle"></span><span>设置白名单</span> </el-col>
                        </el-row>
                        <el-row :gutter="20" style="margin-top:20px;">
                            <el-col :span="whiteSetspan1">
                                <div class="grid-content bg-purple" align="center">名称</div>
                            </el-col>
                            <el-col :span="whiteSetspan2">
                                <div class="grid-content bg-purple" align="center" v-if="!editingWhitePhone">设置</div>
                                <div class="grid-content bg-purple" align="center" v-if="editingWhitePhone">白名单详情</div>
                            </el-col>
                            <el-col :span="whiteSetspan3">
                                <div class="grid-content bg-purple" align="center">操作</div>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20" style="margin-top:5px;line-height:40px;">
                            <el-col :span="whiteSpan1">
                                <div class="grid-content bg-purple" align="center">白名单</div>
                            </el-col>
                            <el-col :span="whiteSpan2">
                                <div class="grid-content bg-purple" align="center">
                                    <div v-if="!editingWhitePhone">
                                        <!-- <el-input v-model="addWhitePhone" style="width:150px;" placeholder="请输入电话号码"></el-input> el-input的change事件是失焦触发  原生的input事件是改变就触发-->
                                        <div class="el-input">
                                            <input type="text" @input="changeWhitePhoneValue" v-model.trim="addWhitePhone"
                                                class="el-input__inner" placeholder="请输入电话号码" />
                                        </div>
                                    </div>
                                    <div v-else>
                                        <span v-if="WatchWhiteList.length == 0">暂无数据</span>

                                        <span v-else><el-button size="mini" type="primary"
                                                @click="dialogFormVisibleWhiteListPhone = true">详情</el-button></span>
                                    </div>
                                </div>
                            </el-col>
                            <el-col :span="whiteSpan3">
                                <div class="grid-content bg-purple" align="center">
                                    <el-button size="mini" type="warning" v-if="editingWhitePhone"
                                        @click="handleAddWhitePhone">添加</el-button>
                                    <el-button size="mini" type="success" :disabled="WhitePhoneDisabled"
                                        v-if="!editingWhitePhone" @click="handleSaveWhitePhone">保存</el-button>
                                    <el-button size="mini" type="info" v-if="!editingWhitePhone"
                                        @click="handleCancelWhitePhone">取消</el-button>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="4"></el-col>
                            <el-col :span="11" :offset="5" v-if="tipShow"
                                :class="{ 'class-error': isError, 'class-ok': isOk }">{{ whitephoneCheckTip }}</el-col>
                            <el-col :span="9"></el-col>
                        </el-row>
                    </el-card>
                </el-col>
                <el-col class="mudiaCol">
                    <el-card shadow="hover" style="height:220px;margin-bottom:5px;">
                        <el-row
                            style="height:180px;display: -webkit-flex;display:flex;flex-direction:row;justify-content:center;align-items:center;">
                            <span style="font-size:30px;color:orange;">敬请期待</span>
                        </el-row>
                    </el-card>
                </el-col>
                <el-col class="mudiaCol">
                    <el-card shadow="hover" style="height:220px;margin-bottom:5px;">
                        <el-row
                            style="height:180px;display: -webkit-flex;display:flex;flex-direction:row;justify-content:center;align-items:center;">
                            <span style="font-size:30px;color:orange;">
                                <el-button style="width:100px;" type="warning" size="medium" @click="goBack">返回</el-button>
                            </span>
                        </el-row>
                    </el-card>
                </el-col>
            </el-row>

            <!-- 弹出安全位置设置-->
            <el-dialog class="el-dialog-map" title="安全区域设置" :visible.sync="dialogFormVisibleSafe"
                :close-on-click-modal="false" :close-on-press-escape="false" @close="closeBangdi">
                <div class="safemap" style="overflow:hidden;">
                    <!-- 添加时的地图 -->
                    <baidu-map class="map" id="map" :center="center" :zoom="zoom" @ready="handler" :scroll-wheel-zoom="true"
                        :mapStyle="mapStyle" :mapType="mapType" @click="getPoint">
                        <bm-scale anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-scale>
                        <bm-navigation anchor="BMAP_ANCHOR_TOP_LEFT"></bm-navigation>
                        <bm-map-type :map-types="['BMAP_NORMAL_MAP', 'BMAP_HYBRID_MAP']"
                            anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-map-type>
                        <bm-overview-map anchor="BMAP_ANCHOR_BOTTOM_RIGHT" @click="getPoint"
                            @:isOpen="true"></bm-overview-map>
                        <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true" :autoLocation="true"
                            @locationSuccess="getLoctionSuccess" @locationError="getLocationError"></bm-geolocation>
                        <bm-city-list anchor="BMAP_ANCHOR_TOP_LEFT"></bm-city-list>
                        <bm-circle :center="postionMap" :radius="radius" stroke-color="blue" :stroke-opacity="0.5"
                            :stroke-weight="2" @lineupdate="updateCirclePath" :editing="true"></bm-circle>
                        <!--信息窗口，show属性是控制显示隐藏，infoWindowClose和infoWindowOpen是控制信息窗口关闭隐藏的方法-->
                        <bm-marker :position="postionMap">
                            <bm-info-window :show="showMark" @close="infoWindowClose" @open="infoWindowOpen"
                                style="font-size: 14px">
                                <p>站点：{{ add.siteName }}</p>
                                <p>站点地址：{{ add.site }}</p>
                            </bm-info-window>
                        </bm-marker>
                    </baidu-map>
                    <div class="saferight">
                        <el-form ref="form" :model="form" :rules="rules" label-width="110px">
                            <el-form-item label="安全区域名称:" style="margin-top:30px;" prop="name">
                                <el-input v-model.trim="form.name" class="formName" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="安全区域开关:">
                                <el-switch v-model="form.isOpen" active-text="开" inactive-text="关">
                                </el-switch>
                            </el-form-item>
                            <el-form-item label="方式:">
                                <el-radio-group v-model="form.alertWay">
                                    <el-col :span=8><el-radio label=0>进出</el-radio></el-col>
                                    <el-col :span=8><el-radio label=1>出去</el-radio></el-col>
                                    <el-col :span=8><el-radio label=2>进入</el-radio></el-col>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="gps经纬度:" prop="gpsString">
                                <span>{{ form.gpsString }}</span>
                            </el-form-item>
                            <el-form-item label="位置:" prop="location">
                                <span>{{ form.location }}</span>
                            </el-form-item>
                            <el-form-item label="安全距离:" prop="safetyRange">
                                <span>{{ form.safetyRange }}米</span>
                            </el-form-item>
                        </el-form>
                        <el-row
                            style="height:50px;display: -webkit-flex;display:flex;flex-direction:row;justify-content:center;align-items:center;">
                            <el-button type="success" @click="submitForm('form')" v-if="addShow">添加</el-button>
                            <el-button type="warning" @click="submitFormEdit('form')" v-if="editShow">修改</el-button>
                        </el-row>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer" align="center">
                    <el-button type="primary" @click="cancelSafe">关闭</el-button>
                </div>
            </el-dialog>

            <!-- 弹出安全区域详情 -->
            <el-dialog title="安全区域详情" :visible.sync="dialogFormVisibleSafeDetail" :close-on-click-modal="false"
                :close-on-press-escape="false" class="SafeDetail" width="30%">
                <div class="table-page">
                    <i-table :list="SafeDetailList" @handleSelectionChange="handleSelectionChange"
                        :options="SafeDetailoptions" :columns="SafeDetailcolumns" :operates="SafeDetailoperates">
                    </i-table>
                </div>
                <el-pagination background @size-change="handleSizeChangeSafe" @current-change="handleCurrentChangeSafe"
                    :current-page="currentPageSafe" layout="total,prev, pager, next" :total="safeDetailtotal"
                    :page-size="pageSizeSafe" align="center" class="fenye">
                </el-pagination>
                <div slot="footer" class="dialog-footer" align="center">
                    <el-button type="primary" @click="dialogFormVisibleSafeDetail = false">关闭</el-button>
                </div>
            </el-dialog>

            <!-- 弹出亲情号码设置-->
            <el-dialog title="亲情号码设置修改" :visible.sync="dialogFormVisiblePhone" :close-on-click-modal="false"
                :close-on-press-escape="false" width="30%">
                <el-form ref="formPhone" :model="formPhone" label-width="150px" :rules="rules">
                    <el-form-item label="红键:" prop="red">
                        <el-input v-model="formPhone.red" style="width:215px;" placeholder="请输入手机号"></el-input>
                    </el-form-item>
                    <el-form-item label="黄键:" prop="yellow">
                        <el-input v-model="formPhone.yellow" style="width:215px;" placeholder="请输入手机号"></el-input>
                    </el-form-item>
                    <el-form-item label="绿键:" prop="green">
                        <el-input v-model="formPhone.green" style="width:215px;" placeholder="请输入手机号"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer" align="center">
                    <el-button @click="cancelphone">取 消</el-button>
                    <el-button type="primary" @click="setPhone('formPhone')">确 定</el-button>
                </div>
            </el-dialog>

            <!-- 弹出智能设置提醒-->
            <el-dialog :title="titleRemind" :visible.sync="dialogFormVisibleRemind" :close-on-click-modal="false"
                :close-on-press-escape="false" class="remind" width="30%" @close="resetRemind">
                <el-form ref="formremind" :model="formremind" label-width="100px">
                    <el-form-item label="闹钟时间 ：">
                        <el-time-picker v-model="formremind.clockTime" format="HH:mm" value-format="HH:mm"
                            @change="changeTimePicker">
                        </el-time-picker>
                    </el-form-item>
                    <el-form-item label="闹钟类型 ：">
                        <el-radio-group v-model="formremind.clockType" @change="changeRadioRemind">
                            <el-row style="margin-bottom:10px;">
                                <el-col>
                                    <el-radio :label="0">吃药提醒</el-radio>
                                    <el-radio :label="1">喝水提醒</el-radio>
                                    <el-radio :label="2">运动提醒</el-radio>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col>
                                    <el-radio :label="3" style="margin-right:36px;">自定义1</el-radio>
                                    <el-radio :label="4" style="margin-right:36px;">自定义2</el-radio>
                                    <el-radio :label="5">自定义3</el-radio>
                                </el-col>
                            </el-row>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="闹钟开关 ：">
                        <el-switch v-model="formremind.clockSwitch" active-text="开" inactive-text="关">
                        </el-switch>
                    </el-form-item>
                    <el-form-item label="设置重复 ：">
                        <el-row>
                            <el-col :span=3>周一 :</el-col>
                            <el-col :span=4>
                                <el-switch v-model="formremind.repeatMon" active-text="是" inactive-text="否">
                                </el-switch>
                            </el-col>
                            <el-col :span=3 :offset=6>周二 :</el-col>
                            <el-col :span=4>
                                <el-switch v-model="formremind.repeatTue" active-text="是" inactive-text="否">
                                </el-switch>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span=3>周三 :</el-col>
                            <el-col :span=4>
                                <el-switch v-model="formremind.repeatWed" active-text="是" inactive-text="否">
                                </el-switch>
                            </el-col>
                            <el-col :span=3 :offset=6>周四 :</el-col>
                            <el-col :span=4>
                                <el-switch v-model="formremind.repeatThu" active-text="是" inactive-text="否">
                                </el-switch>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span=3>周五 :</el-col>
                            <el-col :span=4>
                                <el-switch v-model="formremind.repeatFri" active-text="是" inactive-text="否">
                                </el-switch>
                            </el-col>
                            <el-col :span=3 :offset=6>周六 :</el-col>
                            <el-col :span=4>
                                <el-switch v-model="formremind.repeatSat" active-text="是" inactive-text="否">
                                </el-switch>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span=3>周日 :</el-col>
                            <el-col :span=4>
                                <el-switch v-model="formremind.repeatSun" active-text="是" inactive-text="否">
                                </el-switch>
                            </el-col>
                        </el-row>
                    </el-form-item>
                    <el-form-item label="铃声文件 ：" v-if="remindUploadShow">
                        <el-row style="position:relative;z-index:999">
                            <el-col class="clockfile" style="position:relative;">
                                <input type="file" size="small" id="voiceData_file" @change="changeFileName"
                                    style="opacity:0;z-index:999;cursor:pointer;">
                            </el-col>
                        </el-row>
                        <el-row style="position:absolute;top:0;left:0;z-index:1;height:42px;line-height:42px;">
                            <el-col :span=12 style="position:absolute"><el-button size='small'
                                    style="margin-bottom:5px;position:absolute;top:5px;left:5px;"><span>选取文件</span></el-button></el-col><el-col
                                v-if="showCol" :span=12 style="position:absolute"><span v-if="showAmr"
                                    style="margin-bottom:5px;position:absolute;top:0px;left:90px;display:inline-block;width:200px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">{{ filename }}</span><span
                                    v-if='showImg' style="margin-bottom:5px;position:absolute;top:5px;left:85px;"><img
                                        :src="bg_Icon.amr_icon" alt=""></span></el-col>
                        </el-row>
                        <el-row>
                            <el-col>*请上传小于65k的amr格式铃声文件</el-col>
                        </el-row>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer" align="center">
                    <el-button @click="cancelremind">取 消</el-button>
                    <el-button v-if="remindAddShow" type="primary" @click="submitFormAddRemind('formremind')">添加</el-button>
                    <el-button v-if="remindEditShow" type="warning"
                        @click="submitFormEditRemind('formremind')">修改</el-button>
                </div>
            </el-dialog>

            <!-- 弹出智能提醒设置详情 -->
            <el-dialog title="智能提醒详情" :visible.sync="dialogFormVisibleRemindDetail" :close-on-click-modal="false"
                :close-on-press-escape="false" class="SafeDetail" width="30%">
                <!-- 封装的 i-table组件-->
                <div class="table-page">
                    <i-table :list="getRemindList" @handleSelectionChange="handleSelectionChange" :options="options"
                        :columns="columns" :operates="operates">
                    </i-table>
                </div>
                <el-pagination background @size-change="handleSizeChangeRemind" @current-change="handleCurrentChangeRemind"
                    :current-page="currentPageRemind" layout="total,prev, pager, next" :total="remindtotal"
                    :page-size="pageSizeRemind" align="center" class="fenye">
                </el-pagination>
                <div slot="footer" class="dialog-footer" align="center">
                    <el-button type="primary" @click="dialogFormVisibleRemindDetail = false">关闭</el-button>
                </div>
            </el-dialog>

            <!-- 添加白名单详情-->
            <el-dialog title="白名单详情" class="whitephonelist" :visible.sync="dialogFormVisibleWhiteListPhone"
                :close-on-click-modal="false" :close-on-press-escape="false" width="50%">
                <el-table :data="WatchWhiteList" style="width: 100%" :row-style="tableRowStyle"
                    :header-cell-style="tableHeaderColor">
                    <el-table-column style="height:65px;" label="序号" align="center">
                        <template slot-scope="scope">
                            <span style="margin-left: 10px">{{ scope.$index + 1 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="白名单号码" style="width: 20% height:65px;" align="center">
                        <template slot-scope="scope">
                            <span v-if="!scope.row.editeFlage" style="margin-left: 10px">{{ scope.row.phone }}</span>
                            <!-- el-input的change事件是失焦触发   原生input的input事件是该表就触发  class="el-input__inner"转化成el-input样式-->
                            <!-- <el-input v-if="scope.row.editeFlage" v-model.trim="scope.row.phone" style="width:120px;" placeholder="请输入" @change="changeWhitePhone"></el-input> -->
                            <input type="text" class="el-input__inner" v-if="scope.row.editeFlage" style="width:120px;"
                                v-model.trim="scope.row.phone" placeholder="请输入" @input="changeWhitePhoneEdit" />
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width=150 align="center" style="height:65px;">
                        <template slot-scope="scope">
                            <el-button type="warning" size="mini" v-if="!scope.row.editeFlage"
                                @click="handleEditWhiteListPhone(scope.$index, scope.row)">修改</el-button>
                            <el-button size="mini" type="success" v-if="scope.row.editeFlage"
                                @click="handleSaveWhiteListPhone(scope.$index, scope.row)">保存</el-button>
                            <el-button type="danger" size="mini"
                                @click="handleDeleteWhiteListPhone(scope.$index, scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div slot="footer" class="dialog-footer" align="center">
                    <el-button type="primary" @click="dialogFormVisibleWhiteListPhone = false">关闭</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import number_icon from '@/assets/device/watch/number_icon.png'
import frequency_icon from '@/assets/device/watch/frequency_icon.png'
import quyu_icon from '@/assets/device/watch/quyu_icon.png'
import remind_icon from '@/assets/device/watch/remind_icon.png'
import switch_icon from '@/assets/device/watch/switch_icon.png'
import time_icon from '@/assets/device/watch/time_icon.png'
import Timeslot_icon from '@/assets/device/watch/Timeslot_icon.png'
import volume_icon from '@/assets/device/watch/volume_icon.png'
import Whitelist_icon from '@/assets/device/watch/Whitelist_icon.png'
import amr_icon from '@/assets/device/watch/amr_icon.png'
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
export default {
    data() {
        let switchGps = localStorage.getItem('switchGps') || '';
        //保存状态
        function storeLocalStore(state) {
            window.localStorage.setItem("userMsg", JSON.stringify(state));
        }
        //电话正则
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
        var validPhone = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请输入电话号码'))
            } else if (!reg.test(value)) {
                callback(new Error('请输入正确的11位手机号码'))
            } else {
                callback()
            }
        }
        //时间格式
        Date.prototype.format = function (format) {
            //eg:format="yyyy-MM-dd hh:mm:ss";
            if (!format) {
                format = "yyyy-MM-dd hh:mm:ss";
            }
            var o = {
                "M+": this.getMonth() + 1,  // month
                "d+": this.getDate(),       // day
                "H+": this.getHours(),      // hour
                "h+": this.getHours(),      // hour
                "m+": this.getMinutes(),    // minute
                "s+": this.getSeconds(),    // second
                "q+": Math.floor((this.getMonth() + 3) / 3), // quarter
                "S": this.getMilliseconds()
            };
            if (/(y+)/.test(format)) {
                format = format.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
            }
            for (var k in o) {
                if (new RegExp("(" + k + ")").test(format)) {
                    format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
                }
            }
            return format;
        };
        //初始化的开始和结束时间
        var StartTime = new Date(2019, 1, 22, 0, 0).format("HHmm");
        var EndTime = new Date(2019, 1, 22, 23, 59).format("HHmm");
        return {
            dialogFormVisibleRemindDetail: false,//智能提醒设置详情dialog隐藏
            remindUploadShow: false,//控制上传闹钟铃声的状态，大于2时才显示
            remindEditUploadShow: false,//控制上传闹钟铃声的状态，大于2时才显示
            fileList: [],//上传文件的数组
            clockUrl: '',//提交后台路径
            getRemindList: [],//获取孝心手环智能提醒列表
            totalDataNumber: 0,//数据的总数,
            options: {
                stripe: true, // 是否为斑马纹 table
                //loading: true, // 是否添加表格loading加载动画
                highlightCurrentRow: true, // 是否支持当前行高亮显示
                mutiSelect: false, // 是否支持列表项选中功能
            }, // table 的参数
            columns: [
                {
                    prop: 'clockType',
                    label: '闹钟提醒',
                    align: 'center',
                    formatter: (row, column, cellValue) => {
                        if (row.clockType === 0) {
                            return `<span style="white-space: nowrap;color: red;">吃药提醒</span>`
                        } else if (row.clockType === 1) {
                            return `<span style="white-space: nowrap;color: orange;">喝水提醒</span>`
                        } else if (row.clockType === 2) {
                            return `<span style="white-space: nowrap;color: green;">运动提醒</span>`
                        } else if (row.clockType === 3) {
                            return `<span style="white-space: nowrap;color: grey;">自定义1</span>`
                        } else if (row.clockType === 4) {
                            return `<span style="white-space: nowrap;color: grey;">自定义2</span>`
                        } else {
                            return `<span style="white-space: nowrap;color: grey;">自定义3</span>`
                        }
                    }
                },
                {
                    prop: 'clockSwitch',
                    label: '闹钟开关',
                    align: 'center',
                    formatter: (row, column, cellValue) => {
                        return row.clockSwitch === 0 ? `<span style="white-space: nowrap;color: grey;">关</span>` : `<span style="white-space: nowrap;color: dodgerblue;">开</span>`
                    }
                },
                {
                    prop: 'clockTime',
                    label: '闹钟时间',
                    align: 'center',
                    formatter: (row, column, cellValue) => {
                        var power1 = row.clockTime.substring(0, 2);
                        var power2 = row.clockTime.substring(2, row.clockTime.length);
                        var newPower = power1 + ":" + power2
                        return newPower
                    },
                },
                {
                    prop: 'repeatMon',
                    label: '周一是否重复',
                    align: 'center',
                    formatter: (row, column, cellValue) => {
                        return row.repeatMon === 0 ? `<span style="white-space: nowrap;color: grey;">不重复</span>` : `<span style="white-space: nowrap;color: dodgerblue;">重复</span>`
                    }
                },
                {
                    prop: 'repeatTue',
                    label: '周二是否重复',
                    align: 'center',
                    formatter: (row, column, cellValue) => {
                        return row.repeatTue === 0 ? `<span style="white-space: nowrap;color: grey;">不重复</span>` : `<span style="white-space: nowrap;color: dodgerblue;">重复</span>`
                    }
                },
                {
                    prop: 'repeatWed',
                    label: '周三是否重复',
                    align: 'center',
                    formatter: (row, column, cellValue) => {
                        return row.repeatWed === 0 ? `<span style="white-space: nowrap;color: grey;">不重复</span>` : `<span style="white-space: nowrap;color: dodgerblue;">重复</span>`
                    }
                },
                {
                    prop: 'repeatThu',
                    label: '周四是否重复',
                    align: 'center',
                    formatter: (row, column, cellValue) => {
                        return row.repeatThu === 0 ? `<span style="white-space: nowrap;color: grey;">不重复</span>` : `<span style="white-space: nowrap;color: dodgerblue;">重复</span>`
                    }
                },
                {
                    prop: 'repeatFri',
                    label: '周五是否重复',
                    align: 'center',
                    formatter: (row, column, cellValue) => {
                        return row.repeatFri === 0 ? `<span style="white-space: nowrap;color: grey;">不重复</span>` : `<span style="white-space: nowrap;color: dodgerblue;">重复</span>`
                    }
                },
                {
                    prop: 'repeatSat',
                    label: '周六是否重复',
                    align: 'center',
                    formatter: (row, column, cellValue) => {
                        return row.repeatSat === 0 ? `<span style="white-space: nowrap;color: grey;">不重复</span>` : `<span style="white-space: nowrap;color: dodgerblue;">重复</span>`
                    }
                },
                {
                    prop: 'repeatSun',
                    label: '周日是否重复',
                    align: 'center',
                    formatter: (row, column, cellValue) => {
                        return row.repeatSun === 0 ? `<span style="white-space: nowrap;color: grey;">不重复</span>` : `<span style="white-space: nowrap;color: dodgerblue;">重复</span>`
                    }
                },
                // {
                //     prop: 'isNeed',
                //     label: '是否需要下发',
                //     align: 'center',
                //     formatter: (row, column, cellValue) => {
                //     return row.isNeed===0 ? `<span style="white-space: nowrap;color: grey;">不需要</span>` : `<span style="white-space: nowrap;color: dodgerblue;">需要</span>`
                //     }
                // },
                // {
                //     prop: 'isSend',
                //     label: '是否已经下发',
                //     align: 'center',
                //     formatter: (row, column, cellValue) => {
                //     return row.isSend===0 ? `<span style="white-space: nowrap;color: grey;">待下发</span>` : `<span style="white-space: nowrap;color: dodgerblue;">已下发</span>`
                //     }
                // },

                // //  {
                // //   prop: 'state',
                // //   label: '设备描述',
                // //   align: 'center',
                // //   render: (h, params) => {
                // //    return h('el-tag', {
                // //    props: {type: params.row.state === 0 ? 'success' : params.row.state === 1 ? 'info' : 'danger'} // 组件的props
                // //    }, params.row.state === 0 ? '上架' : params.row.state === 1 ? '下架' : '审核中')
                // //   }
                //  },

            ], // 需要展示的列
            operates: {
                width: 200,
                fixed: 'right',
                offset: 20,
                list: [
                    {
                        id: '1',
                        label: '修改',
                        type: 'warning',
                        show: true,
                        icon: 'el-icon-edit',
                        plain: false,
                        disabled: false,
                        method: (index, row) => {
                            this.handleEditRemind(index, row)
                        }
                    },
                    {
                        id: '2',
                        label: '删除',
                        type: 'danger',
                        icon: 'el-icon-delete',
                        show: true,
                        plain: false,
                        disabled: false,
                        method: (index, row) => {
                            this.handleDeleteRemind(index, row)
                        }
                    },
                    //先去除
                    // {
                    //     id:'3',
                    //     label: '下载语音',
                    //     type: 'success',
                    //     icon: 'el-icon-download',
                    //     show: true,
                    //     plain: false,
                    //     disabled: false,
                    //     method: (index, row) => {
                    //         this.handledownloadRemind(index, row)
                    //     }
                    // },
                ]
            },// 列操作按钮
            bg_Icon: {
                number_icon, frequency_icon, quyu_icon, remind_icon, switch_icon, time_icon, Timeslot_icon, volume_icon, Whitelist_icon, amr_icon
            }, //img小图标
            Optionitem: [],
            deviceId: this.$route.query.id,//设备id
            deviceNo: this.$route.query.deviceNo,//设备编号
            dialogFormVisiblePhone: false,//亲情号设置弹出框
            dialogFormVisibleRemind: false,//设置提醒
            setMessage: "",//所有的设置信息
            timeZone: "东八区",//时区
            timeZoneList: [
                {
                    "value": "西12区",
                    "key": "-12"
                },
                {
                    "value": "西11区",
                    "key": "-11"
                },
                {
                    "value": "西10区",
                    "key": "-10"
                },
                {
                    "value": "西9区",
                    "key": "-9"
                },
                {
                    "value": "西8区",
                    "key": "-8"
                },
                {
                    "value": "西7区",
                    "key": "-7"
                },
                {
                    "value": "西6区",
                    "key": "-6"
                },
                {
                    "value": "西5区",
                    "key": "-5"
                },
                {
                    "value": "西4半区",
                    "key": "-4.5"
                },
                {
                    "value": "西4区",
                    "key": "-4"
                },
                {
                    "value": "西3半区",
                    "key": "-3.5"
                },
                {
                    "value": "西3区",
                    "key": "-3"
                },
                {
                    "value": "西2区",
                    "key": "-2"
                },
                {
                    "value": "西1区",
                    "key": "-1"
                },
                {
                    "value": "0时区",
                    "key": "0"
                },
                {
                    "value": "东1区",
                    "key": "+1"
                },
                {
                    "value": "东2区",
                    "key": "+2"
                },
                {
                    "value": "东3区",
                    "key": "+3"
                },
                {
                    "value": "东3半区",
                    "key": "+3.5"
                },
                {
                    "value": "东4区",
                    "key": "+4"
                },
                {
                    "value": "东4半区",
                    "key": "+4.5"
                },
                {
                    "value": "东5区",
                    "key": "+5"
                },
                {
                    "value": "东5半区",
                    "key": "+5.5"
                },
                {
                    "value": "加德满都",
                    "key": "+5.75"
                },
                {
                    "value": "东6区",
                    "key": "+6"
                },
                {
                    "value": "东7区",
                    "key": "+7"
                },
                {
                    "value": "东8区",
                    "key": "+8"
                },
                {
                    "value": "东9区",
                    "key": "+9"
                },
                {
                    "value": "东10区",
                    "key": "+10"
                },
                {
                    "value": "东11区",
                    "key": "+11"
                },
                {
                    "value": "东12区",
                    "key": "+12"
                },
                {
                    "value": "东13区",
                    "key": "+13"
                }],
            editingtimeZone: true,//设置时区修改保存的状态
            volume: "" * 1,//音量
            heartRate: "1",//心率上传间隔时间
            gpsRate: "1",//gps上传间隔时间
            editingGpsRate: true,//设置Gps上传间隔修改保存的状态
            editingHeartRate: true,//设置心率上传间隔修改保存的状态
            GpsPeriodStart: '00:00',//gps静默的开始时间
            GpsPeriodEnd: '23:59',//gps静默时间结束时间
            gpsperiodjg: "",//后端返回的gps静默时间，需处理时间格式
            editingGpsPeriod: true,//设置Gps静默时间修改保存状态
            PowerPeriodStart: '00:00',//低电量提醒
            PowerPeriodEnd: '23:59',//低电量提醒
            powerperiodjg: "",//后端返回的低电量提醒时间，需处理时间格式
            editingPowerPeriod: true,//设置低电量修改保存状态
            balancePeriodStart: '00:00',//设余额不足提醒时间
            balancePeriodEnd: '23:59',//设余额不足提醒时间
            balanceperiodjg: "",////后端返回的余额不足提醒时间，需处理时间格式
            editingbalancePeriod: true,//设置余额不足修改保存状态
            dialogFormVisibleWhiteListPhone: false,//白名单详情dialog
            WatchWhiteList: [],//白名单列表
            whiteSetspan1: 6,//白名单操作宽度1
            whiteSetspan2: 14,//白名单操作宽度2
            whiteSetspan3: 4,//白名单操作宽度3
            whiteSpan1: 6,//白名单输入宽度1
            whiteSpan2: 14,//白名单输入宽度2
            whiteSpan3: 4,//白名单输入宽度3
            tipShow: false,//白名单号码正则验证信息提示显示隐藏
            isError: false,//白名单号码正则验证信息提示错误
            isOk: false,//白名单号码正则验证信息提示正确
            whitephoneCheckTip: '',//白名单号码正则验证信息提示
            WhitePhoneDisabled: true,//白名单号码输入正确  保存按钮才能点击
            editingWhitePhone: true,//白名单添加保存状态
            addWhitePhone: "",//添加的白名单电话号码
            editWhitePhone: "",//修改的白名单电话号码
            switchGps: 'false',//设置GPS开关
            switchWhite: "false",//设置白名单开关
            switchYellowKeySms: "false",//设置黄名单开关
            switchRedKeySms: "false",//设置红名单开关

            //安全位置设置
            editLng: '',//修改安全位置获取的经度
            editLat: '',//修改安全位置获取的纬度
            dialogFormVisibleSafe: false,//安全位置设置弹出框
            currentPageSafe: 1, //安全区域设置初始页
            pageNumSafe: 1,//安全区域设置页码
            pageSizeSafe: 5,//安全区域设置每页显示的条数
            safeDetailtotal: 0,//
            form: {
                id: "",//安全位置id
                name: "",//安全区域名称
                isOpen: true,//安全区域开关
                alertWay: "0",//报警方式
                gpsString: "",//gps 维度 | 经度
                location: "",//位置
                safetyRange: "",//安全距离
            },
            //百度地图
            center: {//中心点
                lng: 0,
                lat: 0
            },
            zoom: 15,//缩放比例
            radius: 500, //圆圈
            mapType: "",//地图类型，不填就是默认样式
            //设置自定义主题
            mapStyle: {
                styleJson: [
                    {
                        "featureType": "all",
                        "elementType": "geometry",
                        "stylers": {
                            "hue": "#007fff",
                            "saturation": 89
                        }
                    },
                    {
                        "featureType": "water",
                        "elementType": "all",
                        "stylers": {
                            "color": "#ffffff"
                        }
                    }
                ]
            },
            addShow: false,//添加按钮一开始是隐藏的,点击设置的时候才显示
            editShow: false,//修改按钮一开始是隐藏的，点击修改的时候才显示
            dialogFormVisibleSafeDetail: false,//安全区域详情
            SafeDetailList: [],//弹出框安全区域详情列表
            SafeDetailoptions: {
                stripe: true, // 是否为斑马纹 table
                //loading: true, // 是否添加表格loading加载动画
                highlightCurrentRow: true, // 是否支持当前行高亮显示
                mutiSelect: false, // 是否支持列表项选中功能
            }, // table 的参数
            SafeDetailcolumns: [
                // {
                //     prop: 'deviceNo',
                //     label: '设备编号',
                //     align: 'center',
                // },
                // {
                //     prop: 'deviceName',
                //     label: '设备名称',
                //     align: 'center',
                // },
                {
                    prop: 'name',
                    label: '安全范围名称',
                    align: 'center',
                },
                {
                    prop: 'isOpen',
                    label: '开关',
                    align: 'center',
                    formatter: (row, column, cellValue) => {
                        return row.isOpen === 0 ? `<span style="white-space: nowrap;color: grey;">关</span>` : `<span style="white-space: nowrap;color: dodgerblue;">开</span>`
                    }
                },
                {
                    prop: 'alertWay',
                    label: '方式',
                    align: 'center',
                    formatter: (row, column, cellValue) => {
                        return row.alertWay === 0 ? `<span style="white-space: nowrap;color: grey;">进出</span>` : row.alertWay === 1 ? `<span style="white-space: nowrap;color: dodgerblue;">出去</span>` : `<span style="white-space: nowrap;color: dodgerblue;">进入</span>`
                    }
                },
                {
                    prop: 'gpsString',
                    label: 'gps信息',
                    align: 'center',
                },
                {
                    prop: 'location',
                    label: '位置',
                    align: 'center',
                },
                {
                    prop: 'safetyRange',
                    label: '安全距离',
                    align: 'center',
                },
                {
                    prop: 'createdTime',
                    label: '时间',
                    align: 'center',
                },
            ], // 需要展示的列
            SafeDetailoperates: {
                width: 200,
                fixed: 'right',
                offset: 20,
                list: [
                    {
                        id: '1',
                        label: '修改',
                        type: 'warning',
                        show: true,
                        icon: 'el-icon-edit',
                        plain: false,
                        disabled: false,
                        method: (index, row) => {
                            this.handleEditSafeDetail(index, row)
                        }
                    },
                    {
                        id: '2',
                        label: '删除',
                        type: 'danger',
                        icon: 'el-icon-delete',
                        show: true,
                        plain: false,
                        disabled: false,
                        method: (index, row) => {
                            this.handleDeleteSafeDetail(index, row)
                        }
                    },
                ]
            },// 列操作按钮
            postionMap: { lng: 0, lat: 0 },//点击获取经纬度
            add: { jd: "", wd: "", siteName: "", site: "" },//添加的mark
            showMark: false,//Mark点显示隐藏
            //亲情号号码设置
            formPhone: {
                red: "",
                yellow: "",
                green: ""
            },
            //设置智能提醒
            showCol: false,//闹钟铃声图片外层的显示和隐藏
            showAmr: false,//闹钟文件的显示和隐藏
            showImg: false,//闹钟图片的显示和隐藏
            rowVolumn: '',//点击修改时当前列的铃声文件类型
            radioVolumn: '',//radio选择的
            currentPageRemind: 1, //安全区域设置初始页
            pageNumRemind: 1,//安全区域设置页码
            pageSizeRemind: 5,//安全区域设置每页显示的条数
            remindtotal: 0,//智能提醒数据总数
            titleRemind: "",//设置智能提醒dialog的 title默认为空
            remindAddShow: false,//添加提醒按钮 开始是隐藏的
            remindEditShow: false,//修改提醒按钮隐藏 开始是隐藏的
            filename: '',//选取闹钟铃声,显示文件名
            dialogFormVisibleRemind: false,//智能提醒设置弹出框
            formremind: {
                clockType: 0,//闹钟类型
                clockSwitch: true,//闹钟开关
                // clockTime:StartTime,//闹钟时间
                clockTime: "00:00",//闹钟时间 by guo 2019-11-28-16:46修改
                repeatMon: false,//周一是否提醒
                repeatTue: false,//周二是否提醒
                repeatWed: false,//周三是否提醒
                repeatThu: false,//周四是否提醒
                repeatFri: false,//周五是否提醒
                repeatSat: false,//周六是否提醒
                repeatSun: false,//周日是否提醒
                voiceType: 0,//铃声类型
                id: '',//修改提醒的id
                voiceData: '',//铃声
            },

            //修改提醒
            dialogFormVisibleEditRemind: false,//修改框隐藏
            rules: {
                // 新增正则验证匹配规则
                //red: [
                // { required: false, trigger: 'blur', validator: validPhone }//这里需要用到全局变量
                //],
                // yellow: [
                //    { required: false, trigger: 'blur', validator: validPhone }//这里需要用到全局变量
                // ],
                // green: [
                //   { required: false, trigger: 'blur', validator: validPhone }//这里需要用到全局变量
                // ],
                name: [
                    { required: true, min: 1, max: 20, message: '1-20个字符，不能为空', trigger: 'blur' },
                ],
                gpsString: [
                    { required: true, message: '请在地图上选择', },
                ],
                location: [
                    { required: true, message: '请在地图上选择', },
                ]
            },

        }
    },
    methods: {
        //随机生产0-300 的数
        getNumber() {
            for (var i = 0; i <= 300; i++) {
                this.Optionitem = i;
            }
        },
        onSubmit() {
            console.log('submit!');
        },


        // 选中行
        handleSelectionChange(val) {
            console.log('val:', val)
        },

        // 修改table tr行的背景色
        tableRowStyle({ row, rowIndex }) {
            if (rowIndex % 2 == 0) {
                return 'background-color: #efefef'
            } else {
                return 'background-color: #f9f9f9'
            }
        },
        // 修改table header的背景色
        tableHeaderColor({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color:#bee1f4;color:#6f7075;font-weight: 500;'
            }
        },
        //返回上层
        goBack() {
            bus.$emit('close_current_tags');
        },
        //获取地图实例
        handler({ BMap, map }) {
            //(BMap, map)地图组件渲染完毕时触发，返回一个百度地图的核心类和地图实例。百度地图组件是异步加载，
            //请不要尝试在组件的生命周期中访问 BMap 核心类和 map 实例，如有需要，请在所需组件的 ready 事件回调函数的参数中获取。
            console.log(BMap, map)
            //模拟的死数据  这里就确定一个中心点
            // this.center.lng = 114.411256  
            // this.center.lat = 30.480979
            this.zoom = 15
            //获取定位的数据
            var geolocation = new BMap.Geolocation()
            geolocation.getCurrentPosition((r) => {
                if (r.point) {
                    console.log(r.point)
                    this.center.lng = r.longitude
                    this.center.lat = r.latitude
                    var point = new BMap.Point(this.center.lng, this.center.lat);//用当前定位的经纬度查找省市区街道等信息
                    let geocoder = new BMap.Geocoder();  //创建地址解析器的实例
                    console.log(this.center.lng)
                    console.log(this.center.lat)
                    geocoder.getLocation(r.point, rs => {
                        console.log(rs.address);    //这里打印可以看到里面的详细地址信息，可以根据需求选择想要的
                        //以下是获取定位mark点图标的  初始化加载不需要显示mark点图标  就注释点了
                        // let markers = new BMap.Marker(r.point);
                        // console.log(markers);
                        // map.addOverlay(markers); //添加
                        // map.panTo(r.point);
                        // map.centerAndZoom(r.point, 16) ;
                    })
                }
            }, { enableHighAccuracy: true })
        },
        //画圆
        updateCirclePath(e) {
            console.log(e)
            console.log(e.target.getCenter())
            console.log(e.target.getRadius())
            // this.center = e.target.getCenter() //**** 大坑啊******/这里不需要获取中心点，否则点击获取mark时会偏移
            // this.radius = e.target.getRadius()  /*注释点  不然修改的时候安全位置范围会显示当前画圆的值 ，实际上应该回显table当前行的安全范围值*/
            console.log(this.radius)
            console.log(this.center)
            this.form.safetyRange = e.target.getRadius()
            this.form.safetyRange = parseInt(this.form.safetyRange)
        },
        //点击获取mark
        getPoint(e) { //点击地图获取一些信息，
            console.log(e)
            this.show = true;
            this.postionMap.lng = e.point.lng;     //通过  e.point.lng获取经度
            this.postionMap.lat = e.point.lat;     //通过  e.point.lat获取纬度
            this.add.jd = e.point.lng;
            this.add.wd = e.point.lat;
            this.zoom = e.target.getZoom()
            // this.center.lng=e.point.lng; //**** 大坑啊******/这里不需要获取中心点，否则点击获取mark时会偏移
            // this.center.lat=e.point.lat;
            let geocoder = new BMap.Geocoder();  //创建地址解析器的实例
            geocoder.getLocation(e.point, rs => {
                this.add.site = rs.address;
                this.form.location = rs.address;//获取地理位置
                // this.form.gpsString=e.point.lng+'|'+e.point.lat;//by guo 2019-12-10-8:52注释
                this.form.gpsString = e.point.lat + '|' + e.point.lng;
                if (this.form.location != '') {
                    this.$refs.form.clearValidate(); //移除校验结果并重置字段值
                }
                if (this.form.gpsString != '') {
                    this.$refs.form.clearValidate(); //移除校验结果并重置字段值
                }
                //地址描述(string)=
                console.log(rs.address);  //这里打印可以看到里面的详细地址信息，可以根据需求选择想要的
                console.log(rs.addressComponents);//结构化的地址描述(object)
                console.log(rs.addressComponents.province); //省
                console.log(rs.addressComponents.city); //城市
                console.log(rs.addressComponents.district); //区县
                console.log(rs.addressComponents.street); //街道
                console.log(rs.addressComponents.streetNumber); //门牌号
                console.log(rs.surroundingPois); //附近的POI点(array)
                console.log(rs.business); //商圈字段，代表此点所属的商圈(string)
            });
            console.log(e.point);//打印markpoint
        },

        infoWindowClose() {
            this.show = false
        },
        infoWindowOpen() {
            //这里有个问题纠结了很久，百度的信息窗口默认有个点击其他地方就消失的事件，我没有找到
            //并且信息窗口点击一次显示，一次消失
            //于是我加了一个100毫秒的定时器，保证每次点击地图都可以展示信息窗口
            setInterval(() => {
                this.show = true
            }, 100)
        },

        getLoctionSuccess() {

        },
        getLocationError() {

        },

        //dialog关闭  重置
        closeBangdi() {
            this.dialogFormVisibleSafe = false;
            this.$refs.form.resetFields(); //移除校验结果并重置字段值
            this.form.name = '';
            this.form.isOpen = true;
            this.form.alertWay = '0';
            this.form.safetyRange = '500';
            this.radius = '500';
            this.form.location = '';
            this.form.gpsString = '';
            this.postionMap.lng = ''
            this.postionMap.lat = ''
            this.handler({ BMap, map })
            console.log(this.form.safetyRange)
        },

        //点击取消  安全区域设置dialog关闭  
        cancelSafe() {
            this.dialogFormVisibleSafe = false;
            this.$refs.form.resetFields(); //移除校验结果并重置字段值
            this.form.name = '';
            this.form.isOpen = true;
            this.form.alertWay = '0';
            this.form.safetyRange = '500';
            this.radius = '500';
            this.form.location = '';
            this.form.gpsString = '';
            this.postionMap.lng = ''
            this.postionMap.lat = ''
            this.handler({ BMap, map })
        },
        //添加安全区域位置
        submitForm(form) {
            this.$refs[form].validate((valid) => {
                if (valid) {
                    let param = {
                        deviceId: this.deviceId * 1,
                        name: this.form.name,
                        isOpen: Number(this.form.isOpen),
                        alertWay: Number(this.form.alertWay),
                        gpsString: this.form.gpsString,
                        location: this.form.location,
                        safetyRange: Number(this.form.safetyRange)
                    }
                    console.log(param);
                    this.$postJson('dmc/watch/addWatchSafetyRange', param).then((res) => {
                        console.log(res);
                        if (res.code == '10061047') {
                            this.$message({
                                message: res.message,
                                type: 'error'
                            });
                        } else if (res.code == '9999100') {
                            this.$message({
                                message: '孝心手环安全区域范围应大于等于100',
                                type: 'error'
                            });
                        } else {
                            this.submitFormDetail();
                            this.$message({
                                message: res.message,
                                type: 'success'
                            });
                            this.form = {
                                id: "",//安全位置id
                                name: "",//报警位置
                                isOpen: true,//安全区域开关
                                alertWay: "0",//报警方式
                                gpsString: "",//gps 维度 | 经度
                                location: "",//位置
                                safetyRange: "500",//安全距离
                            };
                        }
                    })
                }
            })
        },

        //查询安全区域详情列表
        submitFormDetail() {
            let param = {
                pageNum: this.pageNumSafe,
                pageSize: this.pageSizeSafe,
                deviceId: this.deviceId,
            }
            this.$postJson('dmc/watch/queryWatchSafetyRangeListWithPage', param).then((res) => {
                console.log(res)
                this.SafeDetailList = res.result.list;
                this.pageSizeSafe = res.result.pageSize;
                console.log(this.pageSizeSafe)
                this.currentPageSafe = res.result.pageNum;
                this.safeDetailtotal = res.result.total * 1;
                console.log(this.safeDetailtotal)
            })
        },

        //删除安全区域详情
        handleDeleteSafeDetail(index, row) {
            console.log(index, row)
            this.$confirm('此操作将永久删除该内容, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: true,
                closeOnClickModal: false,
            }).then(() => {
                let id = row.id;
                this.$postForm('dmc/watch/deleteWatchSafetyRangeById/' + id).then((res) => {
                    console.log(res);
                    this.$message({
                        type: 'success',
                        message: '删除成功'
                    });
                    this.submitFormDetail();
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },

        //立即设置按钮弹出添加模态框
        setSafe() {
            this.dialogFormVisibleSafe = true;
            this.addShow = true;
            this.editShow = false;
            this.form = {
                id: "",//安全位置id
                name: "",//报警位置
                isOpen: true,//安全区域开关
                alertWay: "0",//报警方式
                gpsString: "",//gps 维度 | 经度
                location: "",//位置
                safetyRange: "500",//安全距离
            };
        },

        //点击安全设置详情弹出修改的模态框
        safeSetDetail() {
            this.dialogFormVisibleSafeDetail = true;
            this.editShow = true;
            this.addShow = false;
        },

        //修改安全设置弹出模态框
        handleEditSafeDetail(index, row) {
            console.log(this.form.safetyRange)
            console.log(index, row);
            this.dialogFormVisibleSafe = true;
            this.form = Object.assign({}, row);
            console.log(this.form)
            this.form.isOpen = Boolean(this.form.isOpen);
            this.form.alertWay = String(this.form.alertWay);
            this.form.id = row.id;
            this.form.location = row.location;
            this.form.gpsString = row.gpsString;
            this.form.safetyRange = row.safetyRange;
            this.radius = row.safetyRange;
            console.log(this.form.safetyRange)
            console.log(this.radius)
            // this.editLng=row.gpsString.split('|')[0];//by guo 2019-12-10-8:57注释
            // this.editLat=row.gpsString.split('|')[1];
            this.editLat = row.gpsString.split('|')[0];
            this.editLng = row.gpsString.split('|')[1];
            console.log(this.editLng);
            console.log(this.editLat);
            this.getLocation();
        },
        //回显修改的地理
        getLocation() { //获取地图信息，
            this.show = true;
            this.postionMap.lng = this.editLng;     //获取经度
            this.postionMap.lat = this.editLat;     //获取纬度
            this.zoom = 13
            let center = {}
            center.lng = this.postionMap.lng;
            center.lat = this.postionMap.lat;
            console.log(center)
            let geocoder = new BMap.Geocoder();  //创建地址解析器的实例
            geocoder.getLocation((center, rs) => {
                console.log(center);
            });
        },

        //修改安全区域位置
        submitFormEdit(form) {
            this.$refs[form].validate((valid) => {
                if (valid) {
                    let id = this.form.id
                    let param = {
                        id: id * 1,
                        name: this.form.name,
                        isOpen: Number(this.form.isOpen),
                        alertWay: Number(this.form.alertWay),
                        gpsString: this.form.gpsString,
                        location: this.form.location,
                        safetyRange: Number(this.form.safetyRange)
                    }
                    console.log(param);
                    this.$postJson('dmc/watch/editWatchSafetyRange', param).then((res) => {
                        console.log(res);
                        if (res.code == '9999100') {
                            this.$message({
                                message: '孝心手环安全区域范围应大于等于100',
                                type: 'error'
                            })
                        } else if (res.code == '10061047') {
                            this.$message({
                                message: res.message,
                                type: 'error'
                            })
                        } else {
                            this.submitFormDetail();
                            this.$message({
                                message: res.message,
                                type: 'success'
                            });
                            this.dialogFormVisibleSafe = false;
                            this.$refs.form.resetFields(); //移除校验结果并重置字段值
                            this.form.name = '';
                            this.form.isOpen = true;
                            this.form.alertWay = '0';
                            this.form.safetyRange = '500';
                            this.radius = '500';
                            this.form.location = '';
                            this.form.gpsString = '';
                            this.postionMap.lng = ''
                            this.postionMap.lat = ''
                            this.handler({ BMap, map })
                        }
                    })
                }
            })
        },

        //查询手环时区列表
        getTimeZoneList() {
            this.$postJson('dmc/watch/queryWatchTimeZoneList').then((res) => {
                console.log(res)
                //判断是否有数据
                if (res.result) {
                    this.timeZoneList = res.result;
                    console.log(this.timeZoneList)
                } else {
                    this.timeZoneList = [];
                }
            })
        },

        //查询所有设置信息
        getSetMessage() {
            let deviceId = this.deviceId * 1;
            console.log(deviceId)
            this.$postJson('dmc/watch/queryDmcWatchConfigByDeviceId/' + deviceId).then((res) => {
                console.log(res)
                //判断是否有数据
                if (res.result != null) {
                    this.gpsperiodjg = ""
                    this.powerperiodjg = ""
                    this.balanceperiodjg = ""
                    this.setMessage = res.result;
                    console.log(this.setMessage)
                    this.timeZone = this.setMessage.timeZone;
                    this.gpsRate = this.setMessage.gpsRate;
                    this.heartRate = this.setMessage.heartRate;
                    this.PowerPeriod = this.setMessage.PowerPeriod;
                    //用于存放gps时间  显示在时间选择器里面
                    this.GpsPeriodStart = '';//先置空
                    this.GpsPeriodEnd = '';
                    var TimeGps = '';
                    var GpsstartT = '';
                    var GpsendT = '';
                    //处理gps静默时间的格式
                    var gps = res.result.gpsPeriod.split('');//span
                    var Gps = res.result.gpsPeriod.split('');//时间选择器
                    //截取用于在span显示
                    gps.splice(2, 0, ":")
                    gps.splice(5, 0, "-")
                    gps.splice(8, 0, ":")
                    //截取用于在时间选择器显示
                    Gps.splice(2, 0, ":")
                    Gps.splice(7, 0, ":")
                    console.log(gps)
                    console.log(Gps)
                    gps.forEach((item, index) => {
                        this.gpsperiodjg += item;
                    })
                    console.log(this.gpsperiodjg)
                    Gps.forEach((item, index) => {
                        TimeGps += item;
                    })
                    console.log(TimeGps)
                    GpsstartT = TimeGps.substring(0, 5)
                    GpsendT = TimeGps.substring(5, 10)
                    this.GpsPeriodStart = GpsstartT;
                    this.GpsPeriodEnd = GpsendT;
                    console.log(this.GpsPeriodStart, this.GpsPeriodEnd)

                    //用于存放低电量时间  显示在时间选择器里面
                    this.PowerPeriodStart = '';//先置空
                    this.PowerPeriodEnd = '';
                    var TimePower = '';
                    var PowerstartT = '';
                    var PowerendT = '';
                    //处理低电量提醒的时间格式
                    var power = res.result.powerPeriod.split('');
                    var Power = res.result.powerPeriod.split('');//时间选择器
                    //截取放在span
                    power.splice(2, 0, ":")
                    power.splice(5, 0, "-")
                    power.splice(8, 0, ":")
                    console.log(power)
                    //截取用于在时间选择器显示
                    Power.splice(2, 0, ":")
                    Power.splice(7, 0, ":")
                    power.forEach((item, index) => {
                        this.powerperiodjg += item;
                    })
                    Power.forEach((item, index) => {
                        TimePower += item;
                    })
                    console.log(this.powerperiodjg)
                    PowerstartT = TimePower.substring(0, 5)
                    PowerendT = TimePower.substring(5, 10)
                    this.PowerPeriodStart = PowerstartT;
                    this.PowerPeriodEnd = PowerendT;
                    //用于存放低电量时间  显示在时间选择器里面
                    this.balancePeriodStart = '';//先置空
                    this.balancePeriodEnd = ''
                    var Timebalance = '';
                    var balancestartT = '';
                    var balanceendT = '';
                    //处理余额不足提醒的时间格式
                    var balance = res.result.balancePeriod.split('');
                    var Balance = res.result.balancePeriod.split('');
                    //截取用于显示在span
                    balance.splice(2, 0, ":")
                    balance.splice(5, 0, "-")
                    balance.splice(8, 0, ":")
                    //截取用于在时间选择器显示
                    Balance.splice(2, 0, ":")
                    Balance.splice(7, 0, ":")
                    console.log(balance)
                    balance.forEach((item, index) => {
                        this.balanceperiodjg += item;
                    })
                    Balance.forEach((item, index) => {
                        Timebalance += item;
                    })
                    console.log(this.balanceperiodjg)
                    balancestartT = Timebalance.substring(0, 5)
                    balanceendT = Timebalance.substring(5, 10)
                    this.balancePeriodStart = balancestartT;
                    this.balancePeriodEnd = balanceendT;
                    //by guo 2019-11-28-17:24添加
                    res.result.gpsSwitchX = res.result.gpsSwitch == 0 ? false : true;
                    res.result.whiteSwitchX = res.result.whiteSwitch == 0 ? false : true;
                    res.result.yellowKeySwitchX = res.result.yellowKeySwitch == 0 ? false : true;
                    res.result.redKeySwitchX = res.result.redKeySwitch == 0 ? false : true;
                    this.switchGps = res.result.gpsSwitchX;
                    this.switchWhite = res.result.whiteSwitchX;
                    this.switchYellowKeySms = res.result.yellowKeySwitchX;
                    this.switchRedKeySms = res.result.redKeySwitchX;
                    this.volume = res.result.volume;
                } else {
                    this.setMessage = "";
                    this.$message({
                        message: '孝心手环尚未初始化',
                        type: 'error'
                    })
                    setTimeout(() => {
                        bus.$emit('close_current_tags');
                    }, 500)
                }
            })
        },

        //点击设置修改弹出dialog
        setEditPhone() {
            console.log(this.setMessage)
            this.dialogFormVisiblePhone = true;
            //点击设置获取值回显到input框中
            this.$set(this.formPhone, 'red', this.setMessage.redKeyNumber);
            this.$set(this.formPhone, 'yellow', this.setMessage.yellowKeyNumber);
            this.$set(this.formPhone, 'green', this.setMessage.greenKeyNumber);
        },

        //亲情号dialog  取消
        cancelphone() {
            this.dialogFormVisiblePhone = false;
            //this.$refs.formPhone.resetFields(); //移除校验结果并重置字段值//对该表单项进行重置，将其值重置为初始值并移除校验结果
        },

        //设置亲情号的
        setPhone(formPhone) {
            this.$refs[formPhone].validate((valid) => {
                if (valid) {
                    let param = {
                        deviceId: this.deviceId * 1,
                        redKeyNumber: this.formPhone.red,
                        yellowKeyNumber: this.formPhone.yellow,
                        greenKeyNumber: this.formPhone.green
                    }
                    console.log(param)
                    this.$postJson('dmc/watch/setWatchFamilyNumber', param).then((res) => {
                        this.dialogFormVisiblePhone = false;
                        console.log(res)
                        this.getSetMessage();
                        if (res.code == '200') {
                            setTimeout(() => {
                                this.$message({
                                    message: res.message,
                                    type: 'success'
                                });
                            }, 300)
                        } else {
                            if (res.code == '10061005') {
                                this.$message({
                                    message: '红键电话号码错误',
                                    type: 'error'
                                })
                            } else if (res.code == '10061006') {
                                this.$message({
                                    message: '黄键电话号码错误',
                                    type: 'error'
                                })
                            } else if (res.code == '10061007') {
                                this.$message({
                                    message: '绿键电话号码错误',
                                    type: 'error'
                                })
                            }
                        }
                    }).catch((res) => {
                        console.log(res)
                        setTimeout(() => {
                            this.$message({
                                message: res.message,
                                type: 'error'
                            })
                        }, 300)
                    })
                }
            })
        },

        //选择铃声文件出发change函数，文件名显示
        changeFileName(file) {
            console.log(file);
            var files = document.getElementById("voiceData_file").files;
            this.filename = files[0].name;
            console.log(files)
            this.showAmr = true
            this.showImg = false
            this.showCol = true
        },
        //点击立即设置按钮弹出添加智能提醒模态框
        quickSetRemind() {
            this.titleRemind = "添加设置"
            this.dialogFormVisibleRemind = true
            this.remindAddShow = true;
            this.remindEditShow = false;
        },

        //点击取消 重置智能模态框
        cancelremind() {
            this.dialogFormVisibleRemind = false;
            // var StartTime=new Date(2019, 1, 22, 0, 0).format("HHmm");
            var StartTime = "00:00";//2019-11-28-16:46修改

            this.remindUploadShow = false; //重置状态  隐藏铃声上传文件
            //重置所有的状态
            this.formremind = {
                clockType: 0,//闹钟类型
                clockSwitch: true,//闹钟开关
                clockTime: StartTime,//闹钟时间
                repeatMon: false,//周一是否提醒
                repeatTue: false,//周二是否提醒
                repeatWed: false,//周三是否提醒
                repeatThu: false,//周四是否提醒
                repeatFri: false,//周五是否提醒
                repeatSat: false,//周六是否提醒
                repeatSun: false,//周日是否提醒
                voiceType: 0,//铃声类型
            }
            this.filename = '';
            this.showAmr = false
            this.showImg = false
            this.showCol = false
        },
        //添加智能提醒
        submitFormAddRemind(formremind) {
            // 先创建一个FormData对象
            // var param = new FormData(this.formremind);//添加提醒时在火狐浏览器上面报错
            var param = new FormData();
            var time = this.formremind.clockTime.replace(':', '')
            console.log(time)
            console.log(param)
            if (this.formremind.clockType > 2) {
                var files = document.getElementById("voiceData_file").files;
                console.log(files)
                if (files[0]) {
                    param.append('deviceId', this.deviceId)
                    param.append("clockType", Number(this.formremind.clockType))
                    param.append("clockSwitch", Number(this.formremind.clockSwitch))
                    param.append("clockTime", time)
                    param.append("repeatMon", Number(this.formremind.repeatMon))
                    param.append("repeatTue", Number(this.formremind.repeatTue))
                    param.append("repeatWed", Number(this.formremind.repeatWed))
                    param.append("repeatThu", Number(this.formremind.repeatThu))
                    param.append("repeatFri", Number(this.formremind.repeatFri))
                    param.append("repeatSat", Number(this.formremind.repeatSat))
                    param.append("repeatSun", Number(this.formremind.repeatSun))
                    param.append("voiceType", Number(this.formremind.voiceType))
                    param.append("file", files[0])
                    var name = files[0].name.split('.')[1]
                    var size = files[0].size;
                } else {
                    param = undefined
                }
            } else {
                param.append('deviceId', this.deviceId)
                param.append("clockType", Number(this.formremind.clockType))
                param.append("clockSwitch", Number(this.formremind.clockSwitch))
                param.append("clockTime", time)
                param.append("repeatMon", Number(this.formremind.repeatMon))
                param.append("repeatTue", Number(this.formremind.repeatTue))
                param.append("repeatWed", Number(this.formremind.repeatWed))
                param.append("repeatThu", Number(this.formremind.repeatThu))
                param.append("repeatFri", Number(this.formremind.repeatFri))
                param.append("repeatSat", Number(this.formremind.repeatSat))
                param.append("repeatSun", Number(this.formremind.repeatSun))
                param.append("voiceType", Number(this.formremind.voiceType))
            }
            console.log(param);
            var paramBool = (param != undefined);
            console.log(paramBool);
            console.log(name + size)//铃声文件的名称amr  size文件大小
            if (paramBool == true) {
                if (size != 0 && name == "amr" || paramBool == true && files == null) {
                    this.$postFormData('dmc/watch/addDmcWatchAlarmClock', param)
                        .then((res) => {
                            console.log(res);
                            if (res.code == '9999100') {
                                this.$message({
                                    type: 'error',
                                    message: res.message
                                })
                                //by guo 2019-11-28-16 16：50添加
                            } else if (res.code == '10061101') {
                                this.$message({
                                    type: 'error',
                                    message: res.message
                                });
                            } else {
                                this.$message({
                                    type: 'success',
                                    message: res.message
                                });
                            }
                            // var StartTime=new Date(2019, 1, 22, 0, 0).format("HHmm");
                            var StartTime = "00:00";//2019-11-28-16:46修改
                            this.dialogFormVisibleRemind = false
                            //重置所有的状态
                            this.formremind = {
                                clockType: 0,//闹钟类型
                                clockSwitch: true,//闹钟开关
                                clockTime: StartTime,//闹钟时间
                                repeatMon: false,//周一是否提醒
                                repeatTue: false,//周二是否提醒
                                repeatWed: false,//周三是否提醒
                                repeatThu: false,//周四是否提醒
                                repeatFri: false,//周五是否提醒
                                repeatSat: false,//周六是否提醒
                                repeatSun: false,//周日是否提醒
                                voiceType: 0,//铃声类型
                            },
                                this.remindUploadShow = false; //重置状态
                            this.getRemind();
                        })
                } else {
                    this.$message({
                        type: 'error',
                        message: '请上传正确的铃声文件'
                    });
                }
            } else {
                this.$message({
                    type: 'warning',
                    message: '请选择上传铃声文件'
                });
            }
        },

        //时间被改变时触发
        changeTimePicker(value) {
            console.log(value);
            // this.formremind.clockTime=value;
            console.log(this.formremind.clockTime)
        },

        //提醒radio,当闹钟radio值大于2时，让上传铃声的显示
        changeRadioRemind(value) {
            console.log(value);
            if (value > 2) {
                this.remindUploadShow = true;
            } else {
                this.remindUploadShow = false;
                this.showAmr = false
                this.showImg = true
            }
            this.radioVolumn = value;
            console.log(this.radioVolumn);
        },
        //点击修改弹出模态框
        handleEditRemind(index, row) {
            this.titleRemind = "修改设置"
            console.log(index, row);
            this.rowVolumn = row.clockType;
            this.dialogFormVisibleRemind = true;
            this.remindEditShow = true;
            this.remindAddShow = false;
            this.formremind = Object.assign({}, row);//深拷贝记录
            var power1 = row.clockTime.substring(0, 2);
            var power2 = row.clockTime.substring(2, row.clockTime.length);
            var newPower = power1 + ":" + power2;
            //this.formremind.clockTime=newPower;
            this.$set(this.formremind, 'clockTime', newPower)
            console.log(this.formremind);
            //把number类型 0或1转成 boolean类型
            this.formremind.clockSwitch = Boolean(this.formremind.clockSwitch);
            this.formremind.repeatMon = Boolean(this.formremind.repeatMon);
            this.formremind.repeatTue = Boolean(this.formremind.repeatTue);
            this.formremind.repeatWed = Boolean(this.formremind.repeatWed);
            this.formremind.repeatThu = Boolean(this.formremind.repeatThu);
            this.formremind.repeatFri = Boolean(this.formremind.repeatFri);
            this.formremind.repeatSat = Boolean(this.formremind.repeatSat);
            this.formremind.repeatSun = Boolean(this.formremind.repeatSun);
            this.formremind.id = Number(row.id);
            this.formremind.voiceData = this.formremind.voiceData
            // console.log(this.formremind.voiceData)
            //判断铃声文件是否显示true   隐藏 false 
            if (this.formremind.clockType > 2) {
                this.remindUploadShow = true;
                this.showAmr = false
                this.showImg = true
                this.showCol = true
            } else {
                this.remindUploadShow = false;
                this.showAmr = true
                this.showImg = false
                this.showCol = true
            }
        },

        //修改提醒提交数据
        submitFormEditRemind(forme) {
            // 先创建一个FormData对象
            var param = new FormData(this.formeremind);
            var time = this.formremind.clockTime.replace(':', '')
            console.log(param)
            console.log(this.radioVolumn)
            if (this.radioVolumn > 2 && this.rowVolumn > 2) {
                var files = document.getElementById("voiceData_file").files;
                console.log(files)
                if (files[0]) {
                    param.append('id', this.formremind.id)
                    param.append("clockType", Number(this.formremind.clockType))
                    param.append("clockSwitch", Number(this.formremind.clockSwitch))
                    param.append("clockTime", time)
                    param.append("repeatMon", Number(this.formremind.repeatMon))
                    param.append("repeatTue", Number(this.formremind.repeatTue))
                    param.append("repeatWed", Number(this.formremind.repeatWed))
                    param.append("repeatThu", Number(this.formremind.repeatThu))
                    param.append("repeatFri", Number(this.formremind.repeatFri))
                    param.append("repeatSat", Number(this.formremind.repeatSat))
                    param.append("repeatSun", Number(this.formremind.repeatSun))
                    param.append("voiceType", Number(this.formremind.voiceType))
                    param.append("file", files[0])
                } else {
                    param.append('id', this.formremind.id)
                    param.append("clockType", Number(this.formremind.clockType))
                    param.append("clockSwitch", Number(this.formremind.clockSwitch))
                    param.append("clockTime", time)
                    param.append("repeatMon", Number(this.formremind.repeatMon))
                    param.append("repeatTue", Number(this.formremind.repeatTue))
                    param.append("repeatWed", Number(this.formremind.repeatWed))
                    param.append("repeatThu", Number(this.formremind.repeatThu))
                    param.append("repeatFri", Number(this.formremind.repeatFri))
                    param.append("repeatSat", Number(this.formremind.repeatSat))
                    param.append("repeatSun", Number(this.formremind.repeatSun))
                    param.append("voiceType", Number(this.formremind.voiceType))
                }
            } else if (this.radioVolumn > 2 && this.rowVolumn < 2) {
                var files = document.getElementById("voiceData_file").files;
                console.log(files)
                if (files[0]) {
                    param.append('id', this.formremind.id)
                    param.append("clockType", Number(this.formremind.clockType))
                    param.append("clockSwitch", Number(this.formremind.clockSwitch))
                    param.append("clockTime", time)
                    param.append("repeatMon", Number(this.formremind.repeatMon))
                    param.append("repeatTue", Number(this.formremind.repeatTue))
                    param.append("repeatWed", Number(this.formremind.repeatWed))
                    param.append("repeatThu", Number(this.formremind.repeatThu))
                    param.append("repeatFri", Number(this.formremind.repeatFri))
                    param.append("repeatSat", Number(this.formremind.repeatSat))
                    param.append("repeatSun", Number(this.formremind.repeatSun))
                    param.append("voiceType", Number(this.formremind.voiceType))
                    param.append("file", files[0])
                } else {
                    this.$message({
                        type: 'warning',
                        message: '请选择上传铃声文件'
                    });
                    param = undefined
                }
            }
            else {
                param.append('id', this.formremind.id)
                param.append("clockType", Number(this.formremind.clockType))
                param.append("clockSwitch", Number(this.formremind.clockSwitch))
                param.append("clockTime", time)
                param.append("repeatMon", Number(this.formremind.repeatMon))
                param.append("repeatTue", Number(this.formremind.repeatTue))
                param.append("repeatWed", Number(this.formremind.repeatWed))
                param.append("repeatThu", Number(this.formremind.repeatThu))
                param.append("repeatFri", Number(this.formremind.repeatFri))
                param.append("repeatSat", Number(this.formremind.repeatSat))
                param.append("repeatSun", Number(this.formremind.repeatSun))
                param.append("voiceType", Number(this.formremind.voiceType))

            }
            console.log(param);
            var paramBool = (param != undefined);
            console.log(paramBool)
            if (paramBool == true) {
                this.$postFormData('dmc/watch/editDmcWatchAlarmClock', param).then((res) => {
                    console.log(res);
                    if (res.code == '9999100') {
                        this.$message({
                            type: 'error',
                            message: res.message
                        })
                    } else {
                        this.$message({
                            type: 'success',
                            message: res.message
                        });
                    }
                    // var StartTime=new Date(2019, 1, 22, 0, 0).format("HHmm");
                    var StartTime = "00:00";//2019-11-28-16:46修改
                    this.formremind = {
                        clockType: 0,//闹钟类型
                        clockSwitch: true,//闹钟开关
                        clockTime: StartTime,//闹钟时间
                        repeatMon: false,//周一是否提醒
                        repeatTue: false,//周二是否提醒
                        repeatWed: false,//周三是否提醒
                        repeatThu: false,//周四是否提醒
                        repeatFri: false,//周五是否提醒
                        repeatSat: false,//周六是否提醒
                        repeatSun: false,//周日是否提醒
                        voiceType: 0,//铃声类型
                    },
                        this.dialogFormVisibleRemind = false;
                    this.showAmr = false;
                    this.showImg = false;
                    this.showCol = false;
                    this.getRemind();
                })
            }
        },

        //查询智能提醒
        getRemind() {
            let param = {
                pageNum: this.pageNumRemind,
                pageSize: this.pageSizeRemind,
                deviceId: this.deviceId,
                deviceNo: "",
                deviceName: "",
            }
            this.$postJson('dmc/watch/queryDmcWatchAlarmClockListWithPage', param).then((res) => {
                console.log(res);
                if (res.result.list) {
                    this.pageSizeRemind = res.result.pageSize;
                    this.currentPageRemind = res.result.pageNum;
                    this.remindtotal = res.result.total * 1;
                    this.getRemindList = res.result.list;
                } else {

                }
            })
        },

        //删除智能提醒列表
        handleDeleteRemind(index, row) {
            console.log(index, row);
            this.$confirm('此操作将永久删除该内容, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: true,
                closeOnClickModal: false,
            }).then(() => {
                let id = row.id;
                this.$postForm('dmc/watch/deleteDmcWatchAlarmClockById/' + id).then((res) => {
                    console.log(res);
                    this.$message({
                        type: 'success',
                        message: '删除成功'
                    });
                    this.getRemind();
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },

        //下载智能提醒语音文件
        handledownloadRemind(index, row) {
            console.log(index, row);
            var id = row.id
            if (row.clockType > 2) {
                this.$postForm('dmc/auth/downloadDmcWatchAlarmClockVoiceDataById/' + id).then((res) => {
                    console.log(res.data)
                    this.download(res, id)
                })
            } else {
                this.$message({
                    type: 'warning',
                    message: '该闹钟不存在铃声文件'
                });
            }
        },

        // 下载文件
        download(data, id) {
            if (!data) {
                return
            }
            let url = window.URL.createObjectURL(new Blob([data]))
            let link = document.createElement('a')
            link.style.display = 'none'
            link.href = url
            link.setAttribute('download', id + '.amr')

            document.body.appendChild(link)
            link.click()
        },

        //智能提醒设置dialog重新打开时清除里面信息
        resetRemind() {
            this.dialogFormVisibleRemind = false;
            // var StartTime=new Date(2019, 1, 22, 0, 0).format("HHmm");
            var StartTime = "00:00";//2019-11-28-16:46修改
            this.remindUploadShow = false; //重置状态  隐藏铃声上传文件
            //重置所有的状态
            this.formremind = {
                clockType: 0,//闹钟类型
                clockSwitch: true,//闹钟开关
                clockTime: StartTime,//闹钟时间
                repeatMon: false,//周一是否提醒
                repeatTue: false,//周二是否提醒
                repeatWed: false,//周三是否提醒
                repeatThu: false,//周四是否提醒
                repeatFri: false,//周五是否提醒
                repeatSat: false,//周六是否提醒
                repeatSun: false,//周日是否提醒
                voiceType: 0,//铃声类型
            }
            this.filename = ''
        },

        //设置音量
        changeVolumn() {
            console.log("音量发生变化");
            let param = {
                deviceId: this.deviceId * 1,
                volume: this.volume * 1,//把bool值转成number类型
            }
            console.log(param);
            this.$postJson('dmc/watch/setWatchVolume', param).then((res) => {
                console.log(res);
                this.getSetMessage();
            })
        },

        //设置 Gps开关
        changeswitchGps() {
            //this.editingswitchGps=true
            let param = {
                deviceId: this.deviceId * 1,
                switchs: Number(this.switchGps),//把bool值转成number类型
            }
            console.log(param);
            this.$postJson('dmc/watch/setWatchGpsSwitch', param).then((res) => {
                console.log(res);
                this.getSetMessage();
            })
        },


        //设置  白名单开关
        changeswitchWhite() {
            let param = {
                deviceId: this.deviceId * 1,
                switchs: Number(this.switchWhite),//把bool值转成number类型
            }
            console.log(param);
            this.$postJson('dmc/watch/setWatchWhiteListSwitch', param).then((res) => {
                console.log(res);
            })
        },


        //设置  黄键短信开关
        changeswitchYellowKeySms() {
            let param = {
                deviceId: this.deviceId * 1,
                switchs: Number(this.switchYellowKeySms),//把bool值转成number类型
            }
            console.log(param);
            this.$postJson('dmc/watch/setWatchYellowKeySmsSwitch', param).then((res) => {
                console.log(res);
                this.getSetMessage();
            })
        },

        //设置  红键短信开关
        changeswitchRedKeySms() {
            let param = {
                deviceId: this.deviceId * 1,
                switchs: Number(this.switchRedKeySms),//把bool值转成number类型
            }
            console.log(param);
            this.$postJson('dmc/watch/setWatchRedKeySmsSwitch', param).then((res) => {
                console.log(res);
                this.getSetMessage();
            })
        },

        //修改时区
        handleEdittimeZone() {
            this.editingtimeZone = false;
        },

        //保存时区
        handleSavetimeZone() {
            this.editingtimeZone = true
            if (this.timeZone) {
                let param = {
                    deviceId: this.deviceId * 1,
                    timeZone: this.timeZone,
                }
                console.log(param);
                this.$postJson('dmc/watch/setWatchTimeZone', param).then((res) => {
                    console.log(res);
                    this.getSetMessage();
                })
            }
        },

        //修改Gps上传间隔时间
        handleEditGps() {
            this.editingGpsRate = false
        },
        //保存Gps上传间隔时间
        handleSaveGps(data) {
            this.editingGpsRate = true
            if (this.gpsRate) {
                if (this.gpsRate >= 0 && this.gpsRate <= 300) {
                    let param = {
                        deviceId: this.deviceId * 1,
                        gpsRate: this.gpsRate,
                    }
                    console.log(param);
                    this.$postJson('dmc/watch/setWatchGpsUploadRate', param).then((res) => {
                        console.log(res);
                        this.getSetMessage();
                    })
                } else {
                    this.$message({
                        message: '警告，时间间隔在0-300分钟！',
                        type: 'warning'
                    });
                }
            } else {
                this.$message({
                    message: '警告，请选择时间',
                    type: 'warning'
                });
            }
        },
        //修改heart 心率上传间隔时间
        handleEditheart() {
            this.editingHeartRate = false
        },
        //保存heart 心率上传间隔时间
        handleSaveheart() {
            this.editingHeartRate = true
            if (this.heartRate) {
                if (this.heartRate >= 0 && this.heartRate <= 300) {
                    let param = {
                        deviceId: this.deviceId * 1,
                        heartRate: this.heartRate,
                    }
                    console.log(param);
                    this.$postJson('dmc/watch/setWatchHeartUploadRate', param).then((res) => {
                        console.log(res);
                        this.getSetMessage();
                    })
                } else {
                    this.$message({
                        message: '警告，时间间隔在0-300分钟！',
                        type: 'warning'
                    });
                }
            } else {
                this.$message({
                    message: '警告，请选择时间',
                    type: 'warning'
                });
            }
        },

        //修改  Gps静默时间
        handleEditGpsPeriod() {
            this.editingGpsPeriod = false
        },

        //保存  Gps静默时间
        handleSaveGpsPeriod() {
            this.editingGpsPeriod = true
            this.gpsperiodjg = ""
            if (this.GpsPeriodStart != null && this.GpsPeriodEnd != null) {
                var startDate = this.GpsPeriodStart.replace(':', '');
                var endDate = this.GpsPeriodEnd.replace(':', '');
                let param = {
                    deviceId: this.deviceId * 1,
                    periodStart: startDate,
                    periodEnd: endDate
                }
                console.log(param);
                this.$postJson('dmc/watch/setWatchGpsPeriod', param).then((res) => {
                    console.log(res);
                    this.getSetMessage();
                })
            } else {
                this.$message({
                    message: '请选择时间',
                    type: 'warning'
                });
            }
        },

        //修改 低电量提醒时间
        handleEditPowerPeriod() {
            this.editingPowerPeriod = false
        },

        //保存 低电量提醒时间
        handleSavePowerPeriod() {
            this.powerperiodjg = "";
            this.editingPowerPeriod = true
            if (this.PowerPeriodStart != null && this.PowerPeriodEnd != null) {
                var startDate = this.PowerPeriodStart.replace(':', '');
                var endDate = this.PowerPeriodEnd.replace(':', '');
                let param = {
                    deviceId: this.deviceId * 1,
                    periodStart: startDate,
                    periodEnd: endDate
                }
                console.log(param);
                this.$postJson('dmc/watch/setWatchPowerPeriod', param).then((res) => {
                    console.log(res);
                    this.getSetMessage();
                })
            } else {
                this.$message({
                    message: '请选择时间',
                    type: 'warning'
                });
            }
        },

        //修改 余额不足
        handleEditbalancePeriod() {
            this.editingbalancePeriod = false;
        },

        //保存 余额不足
        handleSavebalancePeriod() {
            this.balanceperiodjg = ""
            this.editingbalancePeriod = true;
            if (this.balancePeriodStart != null && this.balancePeriodEnd != null) {
                var startDate = this.balancePeriodStart.replace(':', '');
                var endDate = this.balancePeriodEnd.replace(':', '');
                let param = {
                    deviceId: this.deviceId * 1,
                    periodStart: startDate,
                    periodEnd: endDate
                }
                console.log(param);
                this.$postJson('dmc/watch/setWatchBalancePeriod', param).then((res) => {
                    console.log(res);
                    this.getSetMessage();
                })
            } else {
                this.$message({
                    message: '请选择时间',
                    type: 'warning'
                });
            }
        },

        //添加白名单
        handleAddWhitePhone() {
            this.editingWhitePhone = false;
            this.whiteSetspan1 = 4; //动态控制宽度
            this.whiteSetspan2 = 11;
            this.whiteSetspan3 = 9;
            this.whiteSpan1 = 4;
            this.whiteSpan2 = 11;
            this.whiteSpan3 = 9;
        },

        //点击取消
        handleCancelWhitePhone() {
            this.editingWhitePhone = true;
            this.addWhitePhone = "",
                this.tipShow = false;
            this.WhitePhoneDisabled = true;
            this.whiteSetspan1 = 6;//动态控制宽度
            this.whiteSetspan2 = 14;
            this.whiteSetspan3 = 4;
            this.whiteSpan1 = 6;
            this.whiteSpan2 = 14;
            this.whiteSpan3 = 4;
        },

        //保存白名单
        handleSaveWhitePhone() {
            this.editingWhitePhone = true;
            const reg = /^1[3|5|7|8|9][0-9]\d{8}$/;//电话正则
            if (reg.test(this.addWhitePhone)) {
                let param = {
                    deviceId: this.deviceId,
                    phone: this.addWhitePhone
                }
                console.log(param);
                this.$postJson('dmc/watch/addWatchWhiteListPhone', param).then((res) => {
                    console.log(res);
                    this.$message({
                        message: res.message,
                        type: 'success'
                    });
                    this.getWhitePhone();
                    this.tipShow = false;
                    this.addWhitePhone = "";
                    this.whiteSetspan1 = 6;//动态控制宽度
                    this.whiteSetspan2 = 14;
                    this.whiteSetspan3 = 4;
                    this.whiteSpan1 = 6;
                    this.whiteSpan2 = 14;
                    this.whiteSpan3 = 4;
                })
            } else {
                this.$message({
                    message: '手机号格式错误',
                    type: 'error'
                })
                this.tipShow = false;
                this.addWhitePhone = ""
            }
        },

        //查询孝心手环白名单
        getWhitePhone() {
            let deviceId = this.deviceId;
            this.$postForm('dmc/watch/queryWatchWhiteList/' + deviceId).then((res) => {
                console.log(res);
                if (res.result != null) {
                    var arr = [];
                    res.result.forEach((item, index) => {
                        var obj = {}
                        obj.editeFlage = false;
                        obj.index = index;
                        obj.phone = item
                        arr.push(obj)
                    })
                    this.WatchWhiteList = arr;
                    console.log(this.WatchWhiteList)
                }
            })
        },

        //修改孝心手环白名单触发change事件
        changeWhitePhoneEdit(val) {
            console.log(val)
        },

        //点击修改白名单dialog
        handleEditWhiteListPhone(index, row) {
            console.log(index, row);
            row.editeFlage = true;
        },

        //保存修改孝心手环白名单
        handleSaveWhiteListPhone(index, row) {
            console.log(index, row)
            row.editeFlage = false
            let param = {
                deviceId: this.deviceId,
                phone: row.phone,
                number: index,
            }
            console.log(param);
            this.$postJson('dmc/watch/editWatchWhiteListPhone', param).then((res) => {
                console.log(res);
                this.getWhitePhone();
                if (res.code == '9999100') {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                } else if (res.code == '10061049') {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                } else {
                    this.$message({
                        type: 'success',
                        message: res.message
                    })
                }
            })
        },

        //删除孝心手环白名单
        handleDeleteWhiteListPhone(index, row) {
            this.$confirm('此操作将永久删除该内容, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: true,
                closeOnClickModal: false,
            }).then(() => {
                let param = {
                    deviceId: this.deviceId,
                    number: index
                }
                console.log(param);
                this.$postJson('dmc/watch/deleteWatchWhiteListPhone', param).then((res) => {
                    console.log(res);
                    this.getWhitePhone();
                    this.$message({
                        type: 'success',
                        message: '删除成功'
                    })
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },

        //添加白名单的正则验证
        changeWhitePhoneValue(val) {
            console.log(val)
            console.log(this.addWhitePhone)
            var newArr = []
            if (this.WatchWhiteList.length > 0) {
                this.WatchWhiteList.forEach((item, index) => {
                    newArr.push(item.phone)
                })
            }
            console.log(newArr);
            const reg = /^1[3|5|7|8|9][0-9]\d{8}$/;//电话正则
            if (this.addWhitePhone == "") {
                this.tipShow = false;
            } else if (reg.test(this.addWhitePhone)) {
                //判断添加的手机号是否在数组中，不在就为-1  
                if (newArr.indexOf(this.addWhitePhone) == -1) {
                    this.tipShow = true;
                    this.whitephoneCheckTip = "手机号格式正确"
                    this.isError = false;
                    this.isOk = true;
                    this.WhitePhoneDisabled = false;
                } else {
                    this.tipShow = true;
                    this.whitephoneCheckTip = "手机号已经被添加"
                    this.isError = true;
                    this.isOk = false;
                    this.WhitePhoneDisabled = true;
                }
            } else {
                this.tipShow = true;
                this.whitephoneCheckTip = "手机号格式错误"
                this.isError = true;
                this.isOk = false;
                this.WhitePhoneDisabled = true;
            }
        },

        // 安全区域设置 初始页currentPage、初始每页数据数pagesize和数据data
        handleSizeChangeSafe(val) {
            console.log(`每页 ${val} 条`);
            //安全区域设置 改变每页显示的条数 
            this.pageSizeSafe = val
            this.submitFormDetail();
        },
        handleCurrentChangeSafe(val) {
            console.log(`当前页: ${val}`);
            this.pageNumSafe = val;
            this.submitFormDetail();
        },

        // 智能提醒设置 初始页currentPage、初始每页数据数pagesize和数据data
        handleSizeChangeRemind(val) {
            console.log(`每页 ${val} 条`);
            //智能提醒设置 改变每页显示的条数 
            this.pageSizeRemind = val
            this.getRemind();
        },
        handleCurrentChangeRemind(val) {
            console.log(`当前页: ${val}`);
            this.pageNumRemind = val;
            this.getRemind();
        },

        // 白名单设置 初始页currentPage、初始每页数据数pagesize和数据data
        handleSizeChangeWhite(val) {
            console.log(`每页 ${val} 条`);
            //白名单设置 改变每页显示的条数 
            this.pageSizeWhite = val
            this.getWhitePhone();
        },
        handleCurrentChangeWhite(val) {
            console.log(`当前页: ${val}`);
            this.pageNumWhite = val;
            this.getWhitePhone();
        },
    },
    watch: {
        currentPage(oldV, newV) {
            console.log(oldV, newV);
        },
    },
    created() {
        this.getTimeZoneList();
        this.getSetMessage();
        this.getNumber();
        this.getWhitePhone();
        this.getRemind();
        this.submitFormDetail();
        // this.WatchWhiteList= JSON.parse(localStorage.getItem('WatchWhiteList'))
    },
    //vue中由于页面刷新会导致有些参数被清空，用localStorage存储数据一般是在 beforeMount() 挂载前取， beforeUpdate() 更新渲染时存
    //JSON.parse 转换一下类型
    beforeMount() {
        //by guo 2019-11-28-17:22修改 注释
        // var volumeNum = localStorage.getItem('volume'+this.deviceId);
        // this.volume = JSON.parse(volumeNum);

        // var switchGpsBool=localStorage.getItem('switchGps'+this.deviceId);
        // this.switchGps=JSON.parse(switchGpsBool);

        // var switchWhiteBool=localStorage.getItem('switchWhite'+this.deviceId);
        // this.switchWhite=JSON.parse(switchWhiteBool);

        // var switchYellowKeySmsBool=localStorage.getItem('switchYellowKeySms'+this.deviceId);
        // this.switchYellowKeySms=JSON.parse(switchYellowKeySmsBool);

        // var switchRedKeySmsBool=localStorage.getItem('switchRedKeySms'+this.deviceId);
        // this.switchRedKeySms=JSON.parse(switchRedKeySmsBool);
    },
    mounted() {
    },
    beforeUpdate() {
        //by guo 2019-11-28-17:22修改 注释
        // localStorage.setItem("volume"+this.deviceId,this.volume);
        // localStorage.setItem("switchGps"+this.deviceId,this.switchGps);
        // localStorage.setItem("switchWhite"+this.deviceId,this.switchWhite);
        // localStorage.setItem("switchYellowKeySms"+this.deviceId,this.switchYellowKeySms);
        // localStorage.setItem("switchRedKeySms"+this.deviceId,this.switchRedKeySms);
    },
    watch: {
        focusGpsPeriod() {
            console.log("聚焦了")
        },
        'form': {
            handler(val, oldVal) {
                console.log("form.safetyRange: " + val.safetyRange, oldVal.safetyRange);//但是这两个值打印出来却都是一样的
            },
            deep: true
        }
    },
}
</script>
<style lang="scss" scoped>
.setarea {
    margin: 20px 5px;

    .setarea-a {
        padding: 5px;
        border: 1px solid rgb(243, 234, 234);
    }
}

@media screen and (min-width:1200px) {
     .el-dialog {
        width: 30% !important;
    }
}

@media screen and (min-width:600px) and (max-width:1199px) {
     .el-dialog {
        width: 60% !important;
    }
}

 .el-table-qx {
    width: 80% !important;
    margin: 0 auto;
}

 .is-center {
    height: 65px !important;

}

 .el-card {
    transition: 1s;
    // border:1px solid rgb(218, 205, 205);
    box-shadow: 1px 2px 3px 4px #ccc inset;
}

 .el-card:hover {
    //border:1px solid rgb(36, 34, 34) !important; 
    border: 1px solid rgb(218, 205, 205);
    cursor: pointer;
}

 .el-date-editor {
    width: 200px;
}

//  深度作用选择符
 .el-dialog__header {
    text-align: left;
    background: rgb(238, 231, 231);
    border-bottom: 2px solid rgb(211, 207, 207);
}

 .el-upload-list {
    float: right;
}

 .el-dialog-map .el-dialog {
    width: 95% !important;
}
//地图插件·
 .BMap_stdMpCtrl {
    top: 50px !important;
}

 .citylist_popup_main {
    margin-left: 45px;
}

@media screen and (min-width: 1200px) {
    .safemap {
        border: 1px solid rgb(228, 222, 222);

        .map {
            width: 70%;
            height: 500px;
            float: left;
        }
    }
}

@media screen and (min-width: 600px) and (max-width:1199px) {
    .safemap {
        border: 1px solid rgb(228, 222, 222);

        .map {
            width: 55%;
            height: 500px;
            float: left;
        }
    }
}

@media screen and (min-width: 1200px) {
    .saferight {
        width: 30%;
        height: 500px;
        border: 1px solid #000;
        float: right;
        box-sizing: border-box;
    }
}

@media screen and (min-width:600px) and (max-width: 1199px) {
    .saferight {
        width: 45%;
        height: 500px;
        border: 1px solid #000;
        float: right;
        box-sizing: border-box;
    }
}

//安全区域设置详情
@media screen and (min-width:1200px) {
     .SafeDetail .el-dialog {
        margin-top: 80px !important;
        width: 90% !important;
    }
}

@media screen and (min-width:600px) and (max-width:1199px) {
     .SafeDetail .el-dialog {
        top: 20px !important;
        width: 80% !important;
    }
}

@media screen and (min-width:1200px) and (max-width:1500px) {
     .remind .el-dialog {
        width: 40% !important;
    }
}

.clockfile {
    border: 1px solid rgb(240, 232, 232);
}

//白名单dialog
 .whitephonelist .el-dialog__body {
    height: 400px !important;
    overflow-y: scroll !important;
}

 .el-card__body {
    padding: 20px !important;
}

.class-error {
    color: red;
}

.class-ok {
    color: green;
}

/*适配不同的屏幕*/
@media screen and (min-width:1000px) and (max-width:1530px) {
     .mudiaCol {
        width: 50% !important;
    }
}

@media screen and (min-width:1531px) and (max-width:1920px) {
     .mudiaCol {
        width: 33.333% !important;
    }
}

@media screen and (min-width:1921px) {
     .mudiaCol {
        width: 33.333% !important;
    }
}

@media screen and (min-width:1000px) and (max-width:1530px) {
     .formName .el-input__inner {
        width: 140px !important;
    }
}

@media screen and (min-width:1531px) and (max-width:1920px) {
     .formName .el-input__inner {
        width: 180px !important;
    }
}

@media screen and (min-width:1921px) {
     .formName .el-input__inner {
        width: 180px !important;
    }
}</style>
